import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const cnos = [
  { text: "BT(001)", key: "BT (001)", value: "BT(001)" },
  {
    text: "MANX TELECOM TRADING LIMITED(002)",
    key: "MANX TELECOM TRADING LIMITED(002)",
    value: "MANX TELECOM TRADING LIMITED(002)",
  },
  {
    text: "JT (Jersey) Limited(003)",
    key: "JT (Jersey) Limited(003)",
    value: "JT (Jersey) Limited(003)",
  },
  {
    text: "Eircom (UK) Limited(004)",
    key: "Eircom (UK) Limited(004)",
    value: "Eircom (UK) Limited(004)",
  },
  {
    text: "KCOM Group Limited(005)",
    key: "KCOM Group Limited(005)",
    value: "KCOM Group Limited(005)",
  },
  {
    text: "Telefonica UK Limited(006)",
    key: "Telefonica UK Limited(006)",
    value: "Telefonica UK Limited(006)",
  },
  {
    text: "Vodafone Limited(007)",
    key: "Vodafone Limited(007)",
    value: "Vodafone Limited(007)",
  },
  {
    text: "Starcomm Ltd(009)",
    key: "Starcomm Ltd(009)",
    value: "Starcomm Ltd(009)",
  },
  {
    text: "Pageone Communications Limited(012)",
    key: "Pageone Communications Limited(012)",
    value: "Pageone Communications Limited(012)",
  },
  {
    text: "Vodafone Ltd (C&W)(013)",
    key: "Vodafone Ltd (C&W)(013)",
    value: "Vodafone Ltd (C&W)(013)",
  },
  {
    text: "Sure (Guernsey) Limited(014)",
    key: "Sure (Guernsey) Limited(014)",
    value: "Sure (Guernsey) Limited(014)",
  },
  {
    text: "SMSCGLOBAL LTD(015)",
    key: "SMSCGLOBAL LTD(015)",
    value: "SMSCGLOBAL LTD(015)",
  },
  {
    text: "Virgin Media Limited(016)",
    key: "Virgin Media Limited(016)",
    value: "Virgin Media Limited(016)",
  },
  {
    text: "Virgin Media Limited(017)",
    key: "Virgin Media Limited(017)",
    value: "Virgin Media Limited(017)",
  },
  {
    text: "Entanet International Ltd(018)",
    key: "Entanet International Ltd(018)",
    value: "Entanet International Ltd(018)",
  },
  {
    text: "Stream Live Ltd(019)",
    key: "Stream Live Ltd(019)",
    value: "Stream Live Ltd(019)",
  },
  {
    text: "Virgin Media Limited(020)",
    key: "Virgin Media Limited(020)",
    value: "Virgin Media Limited(020)",
  },
  {
    text: "Virgin Media Limited(021)",
    key: "Virgin Media Limited(021)",
    value: "Virgin Media Limited(021)",
  },
  {
    text: "Buzz Networks Limited(023)",
    key: "Buzz Networks Limited(023)",
    value: "Buzz Networks Limited(023)",
  },
  {
    text: "Sensibill Limited(024)",
    key: "Sensibill Limited(024)",
    value: "Sensibill Limited(024)",
  },
  {
    text: "Verizon UK Limited(025)",
    key: "Verizon UK Limited(025)",
    value: "Verizon UK Limited(025)",
  },
  {
    text: "Vodafone Ltd (Energis)(026)",
    key: "Vodafone Ltd (Energis)(026)",
    value: "Vodafone Ltd (Energis)(026)",
  },
  {
    text: "EE Limited (Orange)(027)",
    key: "EE Limited (Orange)(027)",
    value: "EE Limited (Orange)(027)",
  },
  {
    text: "Vodafone Ltd (Thus)(028)",
    key: "Vodafone Ltd (Thus)(028)",
    value: "Vodafone Ltd (Thus)(028)",
  },
  {
    text: "Affiniti Integrated Solutions Limited(029)",
    key: "Affiniti Integrated Solutions Limited(029)",
    value: "Affiniti Integrated Solutions Limited(029)",
  },
  {
    text: "Orange Business Holdings UK Limited(030)",
    key: "Orange Business Holdings UK Limited(030)",
    value: "Orange Business Holdings UK Limited(030)",
  },
  {
    text: "Gamma Telecom Holdings Ltd(031)",
    key: "Gamma Telecom Holdings Ltd(031)",
    value: "Gamma Telecom Holdings Ltd(031)",
  },
  {
    text: "Communications Networking Services (UK)(032)",
    key: "Communications Networking Services (UK)(032)",
    value: "Communications Networking Services (UK)(032)",
  },
  {
    text: "SKYLINE NETWORKS & CONSULTANCY LTD(034)",
    key: "SKYLINE NETWORKS & CONSULTANCY LTD(034)",
    value: "SKYLINE NETWORKS & CONSULTANCY LTD(034)",
  },
  {
    text: "Vodafone Ltd (YC)(035)",
    key: "Vodafone Ltd (YC)(035)",
    value: "Vodafone Ltd (YC)(035)",
  },
  {
    text: "Reach Europe Ltd(036)",
    key: "Reach Europe Ltd(036)",
    value: "Reach Europe Ltd(036)",
  },
  {
    text: "Virgin Media Limited(039)",
    key: "Virgin Media Limited(039)",
    value: "Virgin Media Limited(039)",
  },
  {
    text: "Colt Technology Services(040)",
    key: "Colt Technology Services(040)",
    value: "Colt Technology Services(040)",
  },
  {
    text: "Virgin Media Limited(041)",
    key: "Virgin Media Limited(041)",
    value: "Virgin Media Limited(041)",
  },
  {
    text: "InTouch Communication Services Limited(042)",
    key: "InTouch Communication Services Limited(042)",
    value: "InTouch Communication Services Limited(042)",
  },
  {
    text: "TGL Services (UK) Ltd(043)",
    key: "TGL Services (UK) Ltd(043)",
    value: "TGL Services (UK) Ltd(043)",
  },
  {
    text: "Alnitak GmbH(045)",
    key: "Alnitak GmbH(045)",
    value: "Alnitak GmbH(045)",
  },
  {
    text: "Virgin Media Limited(046)",
    key: "Virgin Media Limited(046)",
    value: "Virgin Media Limited(046)",
  },
  {
    text: "Initial Technologies Ltd(047)",
    key: "Initial Technologies Ltd(047)",
    value: "Initial Technologies Ltd(047)",
  },
  {
    text: "Lean Wood Communications Limited(048)",
    key: "Lean Wood Communications Limited(048)",
    value: "Lean Wood Communications Limited(048)",
  },
  {
    text: "Virgin Media Limited(049)",
    key: "Virgin Media Limited(049)",
    value: "Virgin Media Limited(049)",
  },
  {
    text: "The Carphone Warehouse Limited(050)",
    key: "The Carphone Warehouse Limited(050)",
    value: "The Carphone Warehouse Limited(050)",
  },
  {
    text: "Virgin Media Limited(051)",
    key: "Virgin Media Limited(051)",
    value: "Virgin Media Limited(051)",
  },
  {
    text: "Virgin Media Limited(052)",
    key: "Virgin Media Limited(052)",
    value: "Virgin Media Limited(052)",
  },
  {
    text: "Link Connect Services Ltd(053)",
    key: "Link Connect Services Ltd(053)",
    value: "Link Connect Services Ltd(053)",
  },
  {
    text: "Syntec Limited(054)",
    key: "Syntec Limited(054)",
    value: "Syntec Limited(054)",
  },
  {
    text: "Redcentric Solutions Limited(055)",
    key: "Redcentric Solutions Limited(055)",
    value: "Redcentric Solutions Limited(055)",
  },
  {
    text: "Virgin Media Limited(056)",
    key: "Virgin Media Limited(056)",
    value: "Virgin Media Limited(056)",
  },
  {
    text: "Dynamic Mobile Billing Limited(057)",
    key: "Dynamic Mobile Billing Limited(057)",
    value: "Dynamic Mobile Billing Limited(057)",
  },
  {
    text: "Virgin Media Limited(058)",
    key: "Virgin Media Limited(058)",
    value: "Virgin Media Limited(058)",
  },
  {
    text: "Virgin Media Limited(059)",
    key: "Virgin Media Limited(059)",
    value: "Virgin Media Limited(059)",
  },
  {
    text: "Subtopia Limited(060)",
    key: "Subtopia Limited(060)",
    value: "Subtopia Limited(060)",
  },
  {
    text: "Pulsant (Scotland) Limited(061)",
    key: "Pulsant (Scotland) Limited(061)",
    value: "Pulsant (Scotland) Limited(061)",
  },
  {
    text: "Virgin Media Limited(062)",
    key: "Virgin Media Limited(062)",
    value: "Virgin Media Limited(062)",
  },
  {
    text: "ESAT Telecommunications (UK) Ltd(064)",
    key: "ESAT Telecommunications (UK) Ltd(064)",
    value: "ESAT Telecommunications (UK) Ltd(064)",
  },
  {
    text: "Vodafone Ltd (Energis)(066)",
    key: "Vodafone Ltd (Energis)(066)",
    value: "Vodafone Ltd (Energis)(066)",
  },
  { text: "IBSC Ltd(068)", key: "IBSC Ltd(068)", value: "IBSC Ltd(068)" },
  {
    text: "Virgin Media Limited(070)",
    key: "Virgin Media Limited(070)",
    value: "Virgin Media Limited(070)",
  },
  {
    text: "Virgin Media Limited(072)",
    key: "Virgin Media Limited(072)",
    value: "Virgin Media Limited(072)",
  },
  {
    text: "Virgin Media Limited(073)",
    key: "Virgin Media Limited(073)",
    value: "Virgin Media Limited(073)",
  },
  {
    text: "Virgin Media Limited(074)",
    key: "Virgin Media Limited(074)",
    value: "Virgin Media Limited(074)",
  },
  {
    text: "Virgin Media Limited(075)",
    key: "Virgin Media Limited(075)",
    value: "Virgin Media Limited(075)",
  },
  {
    text: "Virgin Media Limited(076)",
    key: "Virgin Media Limited(076)",
    value: "Virgin Media Limited(076)",
  },
  {
    text: "FleXtel Limited(077)",
    key: "FleXtel Limited(077)",
    value: "FleXtel Limited(077)",
  },
  {
    text: "Daisy Communications Ltd(078)",
    key: "Daisy Communications Ltd(078)",
    value: "Daisy Communications Ltd(078)",
  },
  {
    text: "Century Link Communications UK Ltd(079)",
    key: "Century Link Communications UK Ltd(079)",
    value: "Century Link Communications UK Ltd(079)",
  },
  {
    text: "Quad Connect Ltd(080)",
    key: "Quad Connect Ltd(080)",
    value: "Quad Connect Ltd(080)",
  },
  {
    text: "Redstone Managed Solutions Ltd(081)",
    key: "Redstone Managed Solutions Ltd(081)",
    value: "Redstone Managed Solutions Ltd(081)",
  },
  {
    text: "Telstra Limited(082)",
    key: "Telstra Limited(082)",
    value: "Telstra Limited(082)",
  },
  {
    text: "Spacetel UK Ltd(084)",
    key: "Spacetel UK Ltd(084)",
    value: "Spacetel UK Ltd(084)",
  },
  {
    text: "Virgin Media Business Limited(085)",
    key: "Virgin Media Business Limited(085)",
    value: "Virgin Media Business Limited(085)",
  },
  {
    text: "Ironbridge Technologies Limited(087)",
    key: "Ironbridge Technologies Limited(087)",
    value: "Ironbridge Technologies Limited(087)",
  },
  {
    text: "Globecom International Limited(088)",
    key: "Globecom International Limited(088)",
    value: "Globecom International Limited(088)",
  },
  { text: "USIC Ltd(090)", key: "USIC Ltd(090)", value: "USIC Ltd(090)" },
  {
    text: "Virgin Media Limited(091)",
    key: "Virgin Media Limited(091)",
    value: "Virgin Media Limited(091)",
  },
  {
    text: "Virgin Media Limited(092)",
    key: "Virgin Media Limited(092)",
    value: "Virgin Media Limited(092)",
  },
  {
    text: "AQL Wholesale Ltd(093)",
    key: "AQL Wholesale Ltd(093)",
    value: "AQL Wholesale Ltd(093)",
  },
  {
    text: "Vodat International Ltd(094)",
    key: "Vodat International Ltd(094)",
    value: "Vodat International Ltd(094)",
  },
  {
    text: "Virgin Media Limited(095)",
    key: "Virgin Media Limited(095)",
    value: "Virgin Media Limited(095)",
  },
  {
    text: "Nova Telecom Ltd(096)",
    key: "Nova Telecom Ltd(096)",
    value: "Nova Telecom Ltd(096)",
  },
  {
    text: "Virgin Media Limited(097)",
    key: "Virgin Media Limited(097)",
    value: "Virgin Media Limited(097)",
  },
  {
    text: "Virgin Media Limited(098)",
    key: "Virgin Media Limited(098)",
    value: "Virgin Media Limited(098)",
  },
  {
    text: "Virgin Media Limited(099)",
    key: "Virgin Media Limited(099)",
    value: "Virgin Media Limited(099)",
  },
  {
    text: "24 Seven Communications Ltd(100)",
    key: "24 Seven Communications Ltd(100)",
    value: "24 Seven Communications Ltd(100)",
  },
  {
    text: "Hospedia Limited(101)",
    key: "Hospedia Limited(101)",
    value: "Hospedia Limited(101)",
  },
  {
    text: "Magrathea Telecommunications Limited(102)",
    key: "Magrathea Telecommunications Limited(102)",
    value: "Magrathea Telecommunications Limited(102)",
  },
  {
    text: "Optify Mediaforce Limited(103)",
    key: "Optify Mediaforce Limited(103)",
    value: "Optify Mediaforce Limited(103)",
  },
  {
    text: "Pipex Communications PLC(105)",
    key: "Pipex Communications PLC(105)",
    value: "Pipex Communications PLC(105)",
  },
  { text: "C2C Ltd(107)", key: "C2C Ltd(107)", value: "C2C Ltd(107)" },
  {
    text: "Premier Voicemail Ltd(108)",
    key: "Premier Voicemail Ltd(108)",
    value: "Premier Voicemail Ltd(108)",
  },
  {
    text: "Digitech Solutions Global Limited(110)",
    key: "Digitech Solutions Global Limited(110)",
    value: "Digitech Solutions Global Limited(110)",
  },
  {
    text: "alwaysON Ltd(111)",
    key: "alwaysON Ltd(111)",
    value: "alwaysON Ltd(111)",
  },
  {
    text: "Hutchison 3G UK Ltd(112)",
    key: "Hutchison 3G UK Ltd(112)",
    value: "Hutchison 3G UK Ltd(112)",
  },
  {
    text: "Sala Trading Ltd(113)",
    key: "Sala Trading Ltd(113)",
    value: "Sala Trading Ltd(113)",
  },
  {
    text: "Barritel Limited(114)",
    key: "Barritel Limited(114)",
    value: "Barritel Limited(114)",
  },
  {
    text: "UK Number Store Limited(116)",
    key: "UK Number Store Limited(116)",
    value: "UK Number Store Limited(116)",
  },
  {
    text: "AOL Europe Services SARL(118)",
    key: "AOL Europe Services SARL(118)",
    value: "AOL Europe Services SARL(118)",
  },
  {
    text: "Connect Telecom UK Ltd(119)",
    key: "Connect Telecom UK Ltd(119)",
    value: "Connect Telecom UK Ltd(119)",
  },
  {
    text: "IV Response Limited(120)",
    key: "IV Response Limited(120)",
    value: "IV Response Limited(120)",
  },
  {
    text: "EE Limited ( TM)(121)",
    key: "EE Limited ( TM)(121)",
    value: "EE Limited ( TM)(121)",
  },
  {
    text: "Reality Network Services Limited(123)",
    key: "Reality Network Services Limited(123)",
    value: "Reality Network Services Limited(123)",
  },
  {
    text: "Trilogy Networks Limited(124)",
    key: "Trilogy Networks Limited(124)",
    value: "Trilogy Networks Limited(124)",
  },
  {
    text: "Networks Direct plc(125)",
    key: "Networks Direct plc(125)",
    value: "Networks Direct plc(125)",
  },
  {
    text: "Global Nomi Telecomunicacoes E Servicos LDA(126)",
    key: "Global Nomi Telecomunicacoes E Servicos LDA(126)",
    value: "Global Nomi Telecomunicacoes E Servicos LDA(126)",
  },
  {
    text: "Citrus Telecommunications Ltd(127)",
    key: "Citrus Telecommunications Ltd(127)",
    value: "Citrus Telecommunications Ltd(127)",
  },
  {
    text: "Video Networks Limited(129)",
    key: "Video Networks Limited(129)",
    value: "Video Networks Limited(129)",
  },
  {
    text: "Updata Infrastructure (UK) Limited(130)",
    key: "Updata Infrastructure (UK) Limited(130)",
    value: "Updata Infrastructure (UK) Limited(130)",
  },
  {
    text: "Wireless Telecommunications Ltd(131)",
    key: "Wireless Telecommunications Ltd(131)",
    value: "Wireless Telecommunications Ltd(131)",
  },
  {
    text: "United Connect Limited(133)",
    key: "United Connect Limited(133)",
    value: "United Connect Limited(133)",
  },
  {
    text: "Abel & Co (Scotland) Ltd(134)",
    key: "Abel & Co (Scotland) Ltd(134)",
    value: "Abel & Co (Scotland) Ltd(134)",
  },
  {
    text: "Virgin Media Limited(135)",
    key: "Virgin Media Limited(135)",
    value: "Virgin Media Limited(135)",
  },
  {
    text: "Wizaner Limited(136)",
    key: "Wizaner Limited(136)",
    value: "Wizaner Limited(136)",
  },
  {
    text: "iHub 2 Limited(138)",
    key: "iHub 2 Limited(138)",
    value: "iHub 2 Limited(138)",
  },
  {
    text: "Vectone Mobile Limited(139)",
    key: "Vectone Mobile Limited(139)",
    value: "Vectone Mobile Limited(139)",
  },
  {
    text: "Digitech Solutions Global Limited(141)",
    key: "Digitech Solutions Global Limited(141)",
    value: "Digitech Solutions Global Limited(141)",
  },
  {
    text: "Synetrix (Holdings) Ltd(143)",
    key: "Synetrix (Holdings) Ltd(143)",
    value: "Synetrix (Holdings) Ltd(143)",
  },
  {
    text: "Telecom 10 Ltd(144)",
    key: "Telecom 10 Ltd(144)",
    value: "Telecom 10 Ltd(144)",
  },
  {
    text: "TalkTalk Communications Limited(145)",
    key: "TalkTalk Communications Limited(145)",
    value: "TalkTalk Communications Limited(145)",
  },
  {
    text: "TalkTalk Communications Limited(147)",
    key: "TalkTalk Communications Limited(147)",
    value: "TalkTalk Communications Limited(147)",
  },
  {
    text: "IPV6 Limited(150)",
    key: "IPV6 Limited(150)",
    value: "IPV6 Limited(150)",
  },
  {
    text: "Virgin Media Limited(151)",
    key: "Virgin Media Limited(151)",
    value: "Virgin Media Limited(151)",
  },
  {
    text: "Virgin Media Limited(152)",
    key: "Virgin Media Limited(152)",
    value: "Virgin Media Limited(152)",
  },
  {
    text: "Virgin Media Limited(153)",
    key: "Virgin Media Limited(153)",
    value: "Virgin Media Limited(153)",
  },
  {
    text: "Virgin Media Limited(154)",
    key: "Virgin Media Limited(154)",
    value: "Virgin Media Limited(154)",
  },
  {
    text: "Virgin Media Limited(155)",
    key: "Virgin Media Limited(155)",
    value: "Virgin Media Limited(155)",
  },
  {
    text: "Icron Network Limited(156)",
    key: "Icron Network Limited(156)",
    value: "Icron Network Limited(156)",
  },
  {
    text: "5G Communications Limited(158)",
    key: "5G Communications Limited(158)",
    value: "5G Communications Limited(158)",
  },
  {
    text: "Six Degrees Technology Group Limited(159)",
    key: "Six Degrees Technology Group Limited(159)",
    value: "Six Degrees Technology Group Limited(159)",
  },
  {
    text: "Edge Telecommunications Limited(161)",
    key: "Edge Telecommunications Limited(161)",
    value: "Edge Telecommunications Limited(161)",
  },
  {
    text: "GPC Computer Software Ltd(163)",
    key: "GPC Computer Software Ltd(163)",
    value: "GPC Computer Software Ltd(163)",
  },
  {
    text: "Business Broadcast Communications Ltd(165)",
    key: "Business Broadcast Communications Ltd(165)",
    value: "Business Broadcast Communications Ltd(165)",
  },
  {
    text: "JT (Guernsey) Limited(166)",
    key: "JT (Guernsey) Limited(166)",
    value: "JT (Guernsey) Limited(166)",
  },
  { text: "TelXL Ltd(169)", key: "TelXL Ltd(169)", value: "TelXL Ltd(169)" },
  {
    text: "Vodafone Ltd (C&W)(170)",
    key: "Vodafone Ltd (C&W)(170)",
    value: "Vodafone Ltd (C&W)(170)",
  },
  {
    text: "Chess Limited(171)",
    key: "Chess Limited(171)",
    value: "Chess Limited(171)",
  },
  {
    text: "Cloud9 Communications Limited(174)",
    key: "Cloud9 Communications Limited(174)",
    value: "Cloud9 Communications Limited(174)",
  },
  {
    text: "Atlas Interactive Group Limited(175)",
    key: "Atlas Interactive Group Limited(175)",
    value: "Atlas Interactive Group Limited(175)",
  },
  {
    text: "Hello Telecom (UK) Limited(176)",
    key: "Hello Telecom (UK) Limited(176)",
    value: "Hello Telecom (UK) Limited(176)",
  },
  {
    text: "Gold Telecom Limited(178)",
    key: "Gold Telecom Limited(178)",
    value: "Gold Telecom Limited(178)",
  },
  {
    text: "Global Electroteks Ltd(179)",
    key: "Global Electroteks Ltd(179)",
    value: "Global Electroteks Ltd(179)",
  },
  {
    text: "Phone Buddy Limited(180)",
    key: "Phone Buddy Limited(180)",
    value: "Phone Buddy Limited(180)",
  },
  {
    text: "SWIFTsoft Computer Systems (NI) Ltd(181)",
    key: "SWIFTsoft Computer Systems (NI) Ltd(181)",
    value: "SWIFTsoft Computer Systems (NI) Ltd(181)",
  },
  {
    text: "LINK MOBILITY UK LTD(182)",
    key: "LINK MOBILITY UK LTD(182)",
    value: "LINK MOBILITY UK LTD(182)",
  },
  {
    text: "Mi Telecom Limited(183)",
    key: "Mi Telecom Limited(183)",
    value: "Mi Telecom Limited(183)",
  },
  {
    text: "Inet Telecoms Ltd (Voipfone)(184)",
    key: "Inet Telecoms Ltd (Voipfone)(184)",
    value: "Inet Telecoms Ltd (Voipfone)(184)",
  },
  {
    text: "Lancaster University Network Services Ltd(186)",
    key: "Lancaster University Network Services Ltd(186)",
    value: "Lancaster University Network Services Ltd(186)",
  },
  {
    text: "Opex Hosting Limited(187)",
    key: "Opex Hosting Limited(187)",
    value: "Opex Hosting Limited(187)",
  },
  {
    text: "Sure (Jersey) Limited(188)",
    key: "Sure (Jersey) Limited(188)",
    value: "Sure (Jersey) Limited(188)",
  },
  {
    text: "Trilogy Telecom Ltd(190)",
    key: "Trilogy Telecom Ltd(190)",
    value: "Trilogy Telecom Ltd(190)",
  },
  {
    text: "Virgin Media Limited(191)",
    key: "Virgin Media Limited(191)",
    value: "Virgin Media Limited(191)",
  },
  {
    text: "Virgin Media Limited(192)",
    key: "Virgin Media Limited(192)",
    value: "Virgin Media Limited(192)",
  },
  {
    text: "Relax Telecom Limited(193)",
    key: "Relax Telecom Limited(193)",
    value: "Relax Telecom Limited(193)",
  },
  {
    text: "Virgin Media Limited(194)",
    key: "Virgin Media Limited(194)",
    value: "Virgin Media Limited(194)",
  },
  {
    text: "Bright Orange Outsourcing Ltd(195)",
    key: "Bright Orange Outsourcing Ltd(195)",
    value: "Bright Orange Outsourcing Ltd(195)",
  },
  {
    text: "Digital Mail Limited(196)",
    key: "Digital Mail Limited(196)",
    value: "Digital Mail Limited(196)",
  },
  {
    text: "Fujitsu Services Limited(197)",
    key: "Fujitsu Services Limited(197)",
    value: "Fujitsu Services Limited(197)",
  },
  {
    text: "Invade International Ltd(198)",
    key: "Invade International Ltd(198)",
    value: "Invade International Ltd(198)",
  },
  {
    text: "G3Comms Limited(202)",
    key: "G3Comms Limited(202)",
    value: "G3Comms Limited(202)",
  },
  {
    text: "Audio Visual Machines Limited(203)",
    key: "Audio Visual Machines Limited(203)",
    value: "Audio Visual Machines Limited(203)",
  },
  {
    text: "Media Telecom Ltd(204)",
    key: "Media Telecom Ltd(204)",
    value: "Media Telecom Ltd(204)",
  },
  {
    text: "Angmar Universal SA(205)",
    key: "Angmar Universal SA(205)",
    value: "Angmar Universal SA(205)",
  },
  {
    text: "A2B Telecom Limited(206)",
    key: "A2B Telecom Limited(206)",
    value: "A2B Telecom Limited(206)",
  },
  {
    text: "HighSpeed Office Limited(207)",
    key: "HighSpeed Office Limited(207)",
    value: "HighSpeed Office Limited(207)",
  },
  {
    text: "Commi Holdings Ltd(208)",
    key: "Commi Holdings Ltd(208)",
    value: "Commi Holdings Ltd(208)",
  },
  {
    text: "Virtual Talk Ltd(211)",
    key: "Virtual Talk Ltd(211)",
    value: "Virtual Talk Ltd(211)",
  },
  { text: "Node4 Ltd(213)", key: "Node4 Ltd(213)", value: "Node4 Ltd(213)" },
  {
    text: "TTNC Limited(215)",
    key: "TTNC Limited(215)",
    value: "TTNC Limited(215)",
  },
  {
    text: "Telconline Inc(216)",
    key: "Telconline Inc(216)",
    value: "Telconline Inc(216)",
  },
  {
    text: "DRD Communications Limited(217)",
    key: "DRD Communications Limited(217)",
    value: "DRD Communications Limited(217)",
  },
  { text: "VODARE LTD(218)", key: "VODARE LTD(218)", value: "VODARE LTD(218)" },
  {
    text: "Be Un Limited(222)",
    key: "Be Un Limited(222)",
    value: "Be Un Limited(222)",
  },
  {
    text: "KCOM Group Limited(223)",
    key: "KCOM Group Limited(223)",
    value: "KCOM Group Limited(223)",
  },
  {
    text: "Affiniti Integrated Solutions Limited(224)",
    key: "Affiniti Integrated Solutions Limited(224)",
    value: "Affiniti Integrated Solutions Limited(224)",
  },
  {
    text: "Vodafone Ltd (Thus)(225)",
    key: "Vodafone Ltd (Thus)(225)",
    value: "Vodafone Ltd (Thus)(225)",
  },
  {
    text: "Griffin Information Systems Ltd(226)",
    key: "Griffin Information Systems Ltd(226)",
    value: "Griffin Information Systems Ltd(226)",
  },
  {
    text: "Xtec Communications Ltd(227)",
    key: "Xtec Communications Ltd(227)",
    value: "Xtec Communications Ltd(227)",
  },
  {
    text: "Mars Communications Limited(228)",
    key: "Mars Communications Limited(228)",
    value: "Mars Communications Limited(228)",
  },
  {
    text: "Easynet Enterprise Services Limited(229)",
    key: "Easynet Enterprise Services Limited(229)",
    value: "Easynet Enterprise Services Limited(229)",
  },
  {
    text: "08Direct Limited(230)",
    key: "08Direct Limited(230)",
    value: "08Direct Limited(230)",
  },
  {
    text: "Virgin Media Limited(231)",
    key: "Virgin Media Limited(231)",
    value: "Virgin Media Limited(231)",
  },
  {
    text: "Transaction Network Services (UK) Limited(232)",
    key: "Transaction Network Services (UK) Limited(232)",
    value: "Transaction Network Services (UK) Limited(232)",
  },
  {
    text: "Morecom Limited(233)",
    key: "Morecom Limited(233)",
    value: "Morecom Limited(233)",
  },
  {
    text: "Synetrix Holdings Limited(234)",
    key: "Synetrix Holdings Limited(234)",
    value: "Synetrix Holdings Limited(234)",
  },
  {
    text: "Abbey Telecom Limited(235)",
    key: "Abbey Telecom Limited(235)",
    value: "Abbey Telecom Limited(235)",
  },
  {
    text: "Beyond Telecommunications Ltd(236)",
    key: "Beyond Telecommunications Ltd(236)",
    value: "Beyond Telecommunications Ltd(236)",
  },
  {
    text: "Caladan Communications Limited(237)",
    key: "Caladan Communications Limited(237)",
    value: "Caladan Communications Limited(237)",
  },
  {
    text: "Elite Limited(239)",
    key: "Elite Limited(239)",
    value: "Elite Limited(239)",
  },
  {
    text: "Zen Internet Limited(241)",
    key: "Zen Internet Limited(241)",
    value: "Zen Internet Limited(241)",
  },
  {
    text: "Telesoft Technologies Limited(242)",
    key: "Telesoft Technologies Limited(242)",
    value: "Telesoft Technologies Limited(242)",
  },
  {
    text: "T-Systems Limited(243)",
    key: "T-Systems Limited(243)",
    value: "T-Systems Limited(243)",
  },
  { text: "AOL UK Ltd(244)", key: "AOL UK Ltd(244)", value: "AOL UK Ltd(244)" },
  {
    text: "Core Communication Services Ltd(245)",
    key: "Core Communication Services Ltd(245)",
    value: "Core Communication Services Ltd(245)",
  },
  {
    text: "Mnet Internet(246)",
    key: "Mnet Internet(246)",
    value: "Mnet Internet(246)",
  },
  {
    text: "MLL Telecom Ltd(247)",
    key: "MLL Telecom Ltd(247)",
    value: "MLL Telecom Ltd(247)",
  },
  {
    text: "Wb-Internet Limited(248)",
    key: "Wb-Internet Limited(248)",
    value: "Wb-Internet Limited(248)",
  },
  {
    text: "Dantec Enterprises Ltd(249)",
    key: "Dantec Enterprises Ltd(249)",
    value: "Dantec Enterprises Ltd(249)",
  },
  {
    text: "Tata Communications (UK) Ltd(250)",
    key: "Tata Communications (UK) Ltd(250)",
    value: "Tata Communications (UK) Ltd(250)",
  },
  {
    text: "Tiscali UK Limited(251)",
    key: "Tiscali UK Limited(251)",
    value: "Tiscali UK Limited(251)",
  },
  {
    text: "TalkTalk Communications Limited(252)",
    key: "TalkTalk Communications Limited(252)",
    value: "TalkTalk Communications Limited(252)",
  },
  {
    text: "KDDI Europe Ltd(253)",
    key: "KDDI Europe Ltd(253)",
    value: "KDDI Europe Ltd(253)",
  },
  {
    text: "Aurora Networks Limited(255)",
    key: "Aurora Networks Limited(255)",
    value: "Aurora Networks Limited(255)",
  },
  {
    text: "Nationwide Telephone Assistance Ltd(256)",
    key: "Nationwide Telephone Assistance Ltd(256)",
    value: "Nationwide Telephone Assistance Ltd(256)",
  },
  {
    text: "Atlas Communications NI Limited(257)",
    key: "Atlas Communications NI Limited(257)",
    value: "Atlas Communications NI Limited(257)",
  },
  {
    text: "Rotel Telecommunications Ltd(258)",
    key: "Rotel Telecommunications Ltd(258)",
    value: "Rotel Telecommunications Ltd(258)",
  },
  {
    text: "IM Software Ltd(259)",
    key: "IM Software Ltd(259)",
    value: "IM Software Ltd(259)",
  },
  {
    text: "Edge Technical Resources Ltd(261)",
    key: "Edge Technical Resources Ltd(261)",
    value: "Edge Technical Resources Ltd(261)",
  },
  {
    text: "Nirenet Limited(262)",
    key: "Nirenet Limited(262)",
    value: "Nirenet Limited(262)",
  },
  {
    text: "Sports Tel Ltd(263)",
    key: "Sports Tel Ltd(263)",
    value: "Sports Tel Ltd(263)",
  },
  {
    text: "Datasharp UK Ltd(264)",
    key: "Datasharp UK Ltd(264)",
    value: "Datasharp UK Ltd(264)",
  },
  { text: "Invoco Ltd(266)", key: "Invoco Ltd(266)", value: "Invoco Ltd(266)" },
  {
    text: "Freeclix Ltd(267)",
    key: "Freeclix Ltd(267)",
    value: "Freeclix Ltd(267)",
  },
  {
    text: "Executel Ltd(268)",
    key: "Executel Ltd(268)",
    value: "Executel Ltd(268)",
  },
  {
    text: "T24 Limited(269)",
    key: "T24 Limited(269)",
    value: "T24 Limited(269)",
  },
  {
    text: "Core Telecom Limited(270)",
    key: "Core Telecom Limited(270)",
    value: "Core Telecom Limited(270)",
  },
  {
    text: "Virgin Media Limited(271)",
    key: "Virgin Media Limited(271)",
    value: "Virgin Media Limited(271)",
  },
  {
    text: "Halo Communications Limited(272)",
    key: "Halo Communications Limited(272)",
    value: "Halo Communications Limited(272)",
  },
  {
    text: "Solar Communications Group Ltd(274)",
    key: "Solar Communications Group Ltd(274)",
    value: "Solar Communications Group Ltd(274)",
  },
  {
    text: "Resilient PLC(275)",
    key: "Resilient PLC(275)",
    value: "Resilient PLC(275)",
  },
  {
    text: "Concert Networks Ltd(276)",
    key: "Concert Networks Ltd(276)",
    value: "Concert Networks Ltd(276)",
  },
  {
    text: "Jtec UK Limited(277)",
    key: "Jtec UK Limited(277)",
    value: "Jtec UK Limited(277)",
  },
  {
    text: "Sweet Telecom Ltd(278)",
    key: "Sweet Telecom Ltd(278)",
    value: "Sweet Telecom Ltd(278)",
  },
  {
    text: "CFL Communications Limited(279)",
    key: "CFL Communications Limited(279)",
    value: "CFL Communications Limited(279)",
  },
  {
    text: "HB Telecom (UK) Ltd(280)",
    key: "HB Telecom (UK) Ltd(280)",
    value: "HB Telecom (UK) Ltd(280)",
  },
  {
    text: "The Midcounties Co-operative Limited(281)",
    key: "The Midcounties Co-operative Limited(281)",
    value: "The Midcounties Co-operative Limited(281)",
  },
  {
    text: "Truphone Ltd(282)",
    key: "Truphone Ltd(282)",
    value: "Truphone Ltd(282)",
  },
  {
    text: "BT Wholesale(283)",
    key: "BT Wholesale(283)",
    value: "BT Wholesale(283)",
  },
  {
    text: "Contact Scotland Ltd(285)",
    key: "Contact Scotland Ltd(285)",
    value: "Contact Scotland Ltd(285)",
  },
  {
    text: "bOnline Ltd.(287)",
    key: "bOnline Ltd.(287)",
    value: "bOnline Ltd.(287)",
  },
  {
    text: "BT Global Services Ltd(288)",
    key: "BT Global Services Ltd(288)",
    value: "BT Global Services Ltd(288)",
  },
  {
    text: "Suretec Systems Ltd(291)",
    key: "Suretec Systems Ltd(291)",
    value: "Suretec Systems Ltd(291)",
  },
  {
    text: "Promotions4All Ltd(292)",
    key: "Promotions4All Ltd(292)",
    value: "Promotions4All Ltd(292)",
  },
  { text: "BT(293)", key: "BT(293)", value: "BT(293)" },
  {
    text: "Numbers Plus Ltd(294)",
    key: "Numbers Plus Ltd(294)",
    value: "Numbers Plus Ltd(294)",
  },
  { text: "Tuxtel Ltd(295)", key: "Tuxtel Ltd(295)", value: "Tuxtel Ltd(295)" },
  {
    text: "Admiral Telecom Limited(296)",
    key: "Admiral Telecom Limited(296)",
    value: "Admiral Telecom Limited(296)",
  },
  {
    text: "IPX Telecom Limited(297)",
    key: "IPX Telecom Limited(297)",
    value: "IPX Telecom Limited(297)",
  },
  {
    text: "(aq) Networks Limited(299)",
    key: "(aq) Networks Limited(299)",
    value: "(aq) Networks Limited(299)",
  },
  {
    text: "Tabsoft Limited(300)",
    key: "Tabsoft Limited(300)",
    value: "Tabsoft Limited(300)",
  },
  {
    text: "Virocom Limited(302)",
    key: "Virocom Limited(302)",
    value: "Virocom Limited(302)",
  },
  {
    text: "Peace Telecom Ltd(303)",
    key: "Peace Telecom Ltd(303)",
    value: "Peace Telecom Ltd(303)",
  },
  {
    text: "Sure (Isle of Man) Limited(304)",
    key: "Sure (Isle of Man) Limited(304)",
    value: "Sure (Isle of Man) Limited(304)",
  },
  {
    text: "Stardex (UK) Limited(305)",
    key: "Stardex (UK) Limited(305)",
    value: "Stardex (UK) Limited(305)",
  },
  {
    text: "Daisy Communications Ltd(306)",
    key: "Daisy Communications Ltd(306)",
    value: "Daisy Communications Ltd(306)",
  },
  {
    text: "Xifos Limited(307)",
    key: "Xifos Limited(307)",
    value: "Xifos Limited(307)",
  },
  {
    text: "V Networks Ltd(308)",
    key: "V Networks Ltd(308)",
    value: "V Networks Ltd(308)",
  },
  {
    text: "Townley Communications plc(309)",
    key: "Townley Communications plc(309)",
    value: "Townley Communications plc(309)",
  },
  {
    text: "QX Telecom Ltd(310)",
    key: "QX Telecom Ltd(310)",
    value: "QX Telecom Ltd(310)",
  },
  {
    text: "Virgin Media Limited(311)",
    key: "Virgin Media Limited(311)",
    value: "Virgin Media Limited(311)",
  },
  {
    text: "Virgin Media Limited(312)",
    key: "Virgin Media Limited(312)",
    value: "Virgin Media Limited(312)",
  },
  {
    text: "Virgin Media Limited(313)",
    key: "Virgin Media Limited(313)",
    value: "Virgin Media Limited(313)",
  },
  {
    text: "UK Data IT Ltd(314)",
    key: "UK Data IT Ltd(314)",
    value: "UK Data IT Ltd(314)",
  },
  {
    text: "Realisys Limited(315)",
    key: "Realisys Limited(315)",
    value: "Realisys Limited(315)",
  },
  {
    text: "Britannic Technologies Ltd(316)",
    key: "Britannic Technologies Ltd(316)",
    value: "Britannic Technologies Ltd(316)",
  },
  {
    text: "Virgin Media Limited(317)",
    key: "Virgin Media Limited(317)",
    value: "Virgin Media Limited(317)",
  },
  {
    text: "Timico Partner Services Limited(318)",
    key: "Timico Partner Services Limited(318)",
    value: "Timico Partner Services Limited(318)",
  },
  {
    text: "Virgin Media Limited(319)",
    key: "Virgin Media Limited(319)",
    value: "Virgin Media Limited(319)",
  },
  {
    text: "Switch Communications(320)",
    key: "Switch Communications(320)",
    value: "Switch Communications(320)",
  },
  {
    text: "Virgin Media Limited(321)",
    key: "Virgin Media Limited(321)",
    value: "Virgin Media Limited(321)",
  },
  {
    text: "Positive ICT Limited(322)",
    key: "Positive ICT Limited(322)",
    value: "Positive ICT Limited(322)",
  },
  {
    text: "Number Solutions Ltd(324)",
    key: "Number Solutions Ltd(324)",
    value: "Number Solutions Ltd(324)",
  },
  {
    text: "Mundio Mobile (Denmark) Limited(325)",
    key: "Mundio Mobile (Denmark) Limited(325)",
    value: "Mundio Mobile (Denmark) Limited(325)",
  },
  {
    text: "Interoute Networks Limited(326)",
    key: "Interoute Networks Limited(326)",
    value: "Interoute Networks Limited(326)",
  },
  {
    text: "TM Solutions Ltd(328)",
    key: "TM Solutions Ltd(328)",
    value: "TM Solutions Ltd(328)",
  },
  {
    text: "Nodemax Limited(329)",
    key: "Nodemax Limited(329)",
    value: "Nodemax Limited(329)",
  },
  {
    text: "Twang.net Ltd(330)",
    key: "Twang.net Ltd(330)",
    value: "Twang.net Ltd(330)",
  },
  {
    text: "Rojo Trading Limited(331)",
    key: "Rojo Trading Limited(331)",
    value: "Rojo Trading Limited(331)",
  },
  {
    text: "Comms Uk Limited(332)",
    key: "Comms Uk Limited(332)",
    value: "Comms Uk Limited(332)",
  },
  {
    text: "Floren Limited(335)",
    key: "Floren Limited(335)",
    value: "Floren Limited(335)",
  },
  {
    text: "ETC Telecom Ltd(338)",
    key: "ETC Telecom Ltd(338)",
    value: "ETC Telecom Ltd(338)",
  },
  {
    text: "South Tyneside Council(339)",
    key: "South Tyneside Council(339)",
    value: "South Tyneside Council(339)",
  },
  {
    text: "XLN Telecom(340)",
    key: "XLN Telecom(340)",
    value: "XLN Telecom(340)",
  },
  {
    text: "Voiceflex Limited(341)",
    key: "Voiceflex Limited(341)",
    value: "Voiceflex Limited(341)",
  },
  {
    text: "Silver Cloud Telecom Limited(342)",
    key: "Silver Cloud Telecom Limited(342)",
    value: "Silver Cloud Telecom Limited(342)",
  },
  {
    text: "Commify UK Limited(343)",
    key: "Commify UK Limited(343)",
    value: "Commify UK Limited(343)",
  },
  {
    text: "Tesco Mobile(345)",
    key: "Tesco Mobile(345)",
    value: "Tesco Mobile(345)",
  },
  {
    text: "Virgin Mobile(346)",
    key: "Virgin Mobile(346)",
    value: "Virgin Mobile(346)",
  },
  {
    text: "Case Communications Limited(347)",
    key: "Case Communications Limited(347)",
    value: "Case Communications Limited(347)",
  },
  {
    text: "Sesui Limited(348)",
    key: "Sesui Limited(348)",
    value: "Sesui Limited(348)",
  },
  {
    text: "Budget Numbers Ltd(349)",
    key: "Budget Numbers Ltd(349)",
    value: "Budget Numbers Ltd(349)",
  },
  {
    text: "Virgin Media Limited(350)",
    key: "Virgin Media Limited(350)",
    value: "Virgin Media Limited(350)",
  },
  {
    text: "Malvern Ventures Limited(351)",
    key: "Malvern Ventures Limited(351)",
    value: "Malvern Ventures Limited(351)",
  },
  {
    text: "Talk Numbers Ltd(352)",
    key: "Talk Numbers Ltd(352)",
    value: "Talk Numbers Ltd(352)",
  },
  {
    text: "Swiftnet Ltd(354)",
    key: "Swiftnet Ltd(354)",
    value: "Swiftnet Ltd(354)",
  },
  {
    text: "Spitfire Network Services Limited(356)",
    key: "Spitfire Network Services Limited(356)",
    value: "Spitfire Network Services Limited(356)",
  },
  {
    text: "Telency Limited(357)",
    key: "Telency Limited(357)",
    value: "Telency Limited(357)",
  },
  {
    text: "Nexus Telecommunications Limited(358)",
    key: "Nexus Telecommunications Limited(358)",
    value: "Nexus Telecommunications Limited(358)",
  },
  {
    text: "Hosted IP Communications (Europe) Limited(359)",
    key: "Hosted IP Communications (Europe) Limited(359)",
    value: "Hosted IP Communications (Europe) Limited(359)",
  },
  {
    text: "Net-Work Internet Ltd(360)",
    key: "Net-Work Internet Ltd(360)",
    value: "Net-Work Internet Ltd(360)",
  },
  {
    text: "The Excell Group Limited(361)",
    key: "The Excell Group Limited(361)",
    value: "The Excell Group Limited(361)",
  },
  {
    text: "Bay Telecom Limited(363)",
    key: "Bay Telecom Limited(363)",
    value: "Bay Telecom Limited(363)",
  },
  {
    text: "Virgin Media Limited(364)",
    key: "Virgin Media Limited(364)",
    value: "Virgin Media Limited(364)",
  },
  {
    text: "Telecoms Consortium Ltd(365)",
    key: "Telecoms Consortium Ltd(365)",
    value: "Telecoms Consortium Ltd(365)",
  },
  {
    text: "VoIP-Un Limited(367)",
    key: "VoIP-Un Limited(367)",
    value: "VoIP-Un Limited(367)",
  },
  {
    text: "TeleWare Group PLC(369)",
    key: "TeleWare Group PLC(369)",
    value: "TeleWare Group PLC(369)",
  },
  {
    text: "Assume Nothing Limited(374)",
    key: "Assume Nothing Limited(374)",
    value: "Assume Nothing Limited(374)",
  },
  {
    text: "Timico Limited(376)",
    key: "Timico Limited(376)",
    value: "Timico Limited(376)",
  },
  {
    text: "BT OnePhone Limited(377)",
    key: "BT OnePhone Limited(377)",
    value: "BT OnePhone Limited(377)",
  },
  {
    text: "Intercity Technology Ltd(378)",
    key: "Intercity Technology Ltd(378)",
    value: "Intercity Technology Ltd(378)",
  },
  {
    text: "Mainstream Digital Ltd(379)",
    key: "Mainstream Digital Ltd(379)",
    value: "Mainstream Digital Ltd(379)",
  },
  {
    text: "Virgin Media Limited(381)",
    key: "Virgin Media Limited(381)",
    value: "Virgin Media Limited(381)",
  },
  {
    text: "MDNX Managed Services Ltd(382)",
    key: "MDNX Managed Services Ltd(382)",
    value: "MDNX Managed Services Ltd(382)",
  },
  {
    text: "Virgin Media Limited(383)",
    key: "Virgin Media Limited(383)",
    value: "Virgin Media Limited(383)",
  },
  {
    text: "Virgin Media Limited(384)",
    key: "Virgin Media Limited(384)",
    value: "Virgin Media Limited(384)",
  },
  {
    text: "Sigma Voice Solutions Ltd(385)",
    key: "Sigma Voice Solutions Ltd(385)",
    value: "Sigma Voice Solutions Ltd(385)",
  },
  { text: "Voxbone SA(388)", key: "Voxbone SA(388)", value: "Voxbone SA(388)" },
  {
    text: "Pinnacle Telecoms Wales(389)",
    key: "Pinnacle Telecoms Wales(389)",
    value: "Pinnacle Telecoms Wales(389)",
  },
  { text: "Digital ip(391)", key: "Digital ip(391)", value: "Digital ip(391)" },
  {
    text: "TelNG Limited(394)",
    key: "TelNG Limited(394)",
    value: "TelNG Limited(394)",
  },
  {
    text: "Telecom2 Limited(395)",
    key: "Telecom2 Limited(395)",
    value: "Telecom2 Limited(395)",
  },
  {
    text: "Telappliant Ltd(396)",
    key: "Telappliant Ltd(396)",
    value: "Telappliant Ltd(396)",
  },
  {
    text: "Nexbridge Communications Limited(397)",
    key: "Nexbridge Communications Limited(397)",
    value: "Nexbridge Communications Limited(397)",
  },
  {
    text: "Vibe Communications UK Ltd(400)",
    key: "Vibe Communications UK Ltd(400)",
    value: "Vibe Communications UK Ltd(400)",
  },
  {
    text: "Served Up Limited(401)",
    key: "Served Up Limited(401)",
    value: "Served Up Limited(401)",
  },
  {
    text: "Kenton Research Limited(403)",
    key: "Kenton Research Limited(403)",
    value: "Kenton Research Limited(403)",
  },
  {
    text: "Thales Transport and Security Limited(404)",
    key: "Thales Transport and Security Limited(404)",
    value: "Thales Transport and Security Limited(404)",
  },
  {
    text: "Virgin Media Limited(405)",
    key: "Virgin Media Limited(405)",
    value: "Virgin Media Limited(405)",
  },
  {
    text: "UTV Internet(406)",
    key: "UTV Internet(406)",
    value: "UTV Internet(406)",
  },
  {
    text: "OVH Limited(407)",
    key: "OVH Limited(407)",
    value: "OVH Limited(407)",
  },
  {
    text: "Glide Student and Residential Limited(409)",
    key: "Glide Student and Residential Limited(409)",
    value: "Glide Student and Residential Limited(409)",
  },
  {
    text: "Vtesse Networks Limited(410)",
    key: "Vtesse Networks Limited(410)",
    value: "Vtesse Networks Limited(410)",
  },
  {
    text: "Real Telekom Ltd(412)",
    key: "Real Telekom Ltd(412)",
    value: "Real Telekom Ltd(412)",
  },
  {
    text: "Internet Technology Products Ltd(413)",
    key: "Internet Technology Products Ltd(413)",
    value: "Internet Technology Products Ltd(413)",
  },
  {
    text: "Talking Technology Limited(414)",
    key: "Talking Technology Limited(414)",
    value: "Talking Technology Limited(414)",
  },
  {
    text: "Virgin Media Limited(415)",
    key: "Virgin Media Limited(415)",
    value: "Virgin Media Limited(415)",
  },
  {
    text: "Met Technologies Limited(416)",
    key: "Met Technologies Limited(416)",
    value: "Met Technologies Limited(416)",
  },
  {
    text: "Titan Technology Limited(418)",
    key: "Titan Technology Limited(418)",
    value: "Titan Technology Limited(418)",
  },
  {
    text: "Guernsey Airtel Limited(419)",
    key: "Guernsey Airtel Limited(419)",
    value: "Guernsey Airtel Limited(419)",
  },
  {
    text: "Jersey Airtel Limited(420)",
    key: "Jersey Airtel Limited(420)",
    value: "Jersey Airtel Limited(420)",
  },
  {
    text: "Virgin Media Limited(421)",
    key: "Virgin Media Limited(421)",
    value: "Virgin Media Limited(421)",
  },
  {
    text: "Virgin Media Limited(422)",
    key: "Virgin Media Limited(422)",
    value: "Virgin Media Limited(422)",
  },
  {
    text: "Bicom Systems EURL(423)",
    key: "Bicom Systems EURL(423)",
    value: "Bicom Systems EURL(423)",
  },
  {
    text: "Easynet Network Services Limited(424)",
    key: "Easynet Network Services Limited(424)",
    value: "Easynet Network Services Limited(424)",
  },
  {
    text: "Telecoms World Direct Ltd(426)",
    key: "Telecoms World Direct Ltd(426)",
    value: "Telecoms World Direct Ltd(426)",
  },
  {
    text: "Rainton. Net Ltd(427)",
    key: "Rainton. Net Ltd(427)",
    value: "Rainton. Net Ltd(427)",
  },
  {
    text: "Midshire Business Systems (Communications) Ltd(428)",
    key: "Midshire Business Systems (Communications) Ltd(428)",
    value: "Midshire Business Systems (Communications) Ltd(428)",
  },
  {
    text: "Venus Business Communications Limited(429)",
    key: "Venus Business Communications Limited(429)",
    value: "Venus Business Communications Limited(429)",
  },
  {
    text: "Virgin Media Limited(430)",
    key: "Virgin Media Limited(430)",
    value: "Virgin Media Limited(430)",
  },
  {
    text: "Virgin Media Limited(431)",
    key: "Virgin Media Limited(431)",
    value: "Virgin Media Limited(431)",
  },
  {
    text: "Virgin Media Limited(432)",
    key: "Virgin Media Limited(432)",
    value: "Virgin Media Limited(432)",
  },
  {
    text: "Virgin Media Limited(433)",
    key: "Virgin Media Limited(433)",
    value: "Virgin Media Limited(433)",
  },
  {
    text: "Network Extender Technologies Limited(434)",
    key: "Network Extender Technologies Limited(434)",
    value: "Network Extender Technologies Limited(434)",
  },
  {
    text: "Virgin Media Limited(435)",
    key: "Virgin Media Limited(435)",
    value: "Virgin Media Limited(435)",
  },
  {
    text: "London Central Communications Ltd(436)",
    key: "London Central Communications Ltd(436)",
    value: "London Central Communications Ltd(436)",
  },
  {
    text: "Itec Support Limited(437)",
    key: "Itec Support Limited(437)",
    value: "Itec Support Limited(437)",
  },
  {
    text: "Beaming Limited(438)",
    key: "Beaming Limited(438)",
    value: "Beaming Limited(438)",
  },
  {
    text: "Pure-IP Limited(439)",
    key: "Pure-IP Limited(439)",
    value: "Pure-IP Limited(439)",
  },
  {
    text: "Virgin Media Limited(440)",
    key: "Virgin Media Limited(440)",
    value: "Virgin Media Limited(440)",
  },
  {
    text: "Virgin Media Limited(441)",
    key: "Virgin Media Limited(441)",
    value: "Virgin Media Limited(441)",
  },
  {
    text: "Virgin Media Limited(442)",
    key: "Virgin Media Limited(442)",
    value: "Virgin Media Limited(442)",
  },
  {
    text: "Virgin Media Limited(443)",
    key: "Virgin Media Limited(443)",
    value: "Virgin Media Limited(443)",
  },
  {
    text: "Virgin Media Limited(444)",
    key: "Virgin Media Limited(444)",
    value: "Virgin Media Limited(444)",
  },
  {
    text: "Virgin Media Limited(445)",
    key: "Virgin Media Limited(445)",
    value: "Virgin Media Limited(445)",
  },
  {
    text: "Virgin Media Limited(446)",
    key: "Virgin Media Limited(446)",
    value: "Virgin Media Limited(446)",
  },
  {
    text: "Virgin Media Limited(447)",
    key: "Virgin Media Limited(447)",
    value: "Virgin Media Limited(447)",
  },
  {
    text: "Virgin Media Limited(448)",
    key: "Virgin Media Limited(448)",
    value: "Virgin Media Limited(448)",
  },
  {
    text: "Virgin Media Limited(449)",
    key: "Virgin Media Limited(449)",
    value: "Virgin Media Limited(449)",
  },
  {
    text: "Virgin Media Limited(450)",
    key: "Virgin Media Limited(450)",
    value: "Virgin Media Limited(450)",
  },
  {
    text: "Virgin Media Limited(451)",
    key: "Virgin Media Limited(451)",
    value: "Virgin Media Limited(451)",
  },
  {
    text: "LegendTel LLC(453)",
    key: "LegendTel LLC(453)",
    value: "LegendTel LLC(453)",
  },
  {
    text: "Core Telecommunications International Limited (Ireland)(454)",
    key: "Core Telecommunications International Limited (Ireland)(454)",
    value: "Core Telecommunications International Limited (Ireland)(454)",
  },
  {
    text: "Virgin Media Limited(455)",
    key: "Virgin Media Limited(455)",
    value: "Virgin Media Limited(455)",
  },
  {
    text: "Virgin Media Limited(457)",
    key: "Virgin Media Limited(457)",
    value: "Virgin Media Limited(457)",
  },
  {
    text: "Transglobal UK Limited(458)",
    key: "Transglobal UK Limited(458)",
    value: "Transglobal UK Limited(458)",
  },
  {
    text: "Service Direct Newco Limited(459)",
    key: "Service Direct Newco Limited(459)",
    value: "Service Direct Newco Limited(459)",
  },
  {
    text: "Virgin Media Limited(460)",
    key: "Virgin Media Limited(460)",
    value: "Virgin Media Limited(460)",
  },
  {
    text: "Via-Vox Limited(461)",
    key: "Via-Vox Limited(461)",
    value: "Via-Vox Limited(461)",
  },
  {
    text: "Unisys Limited(463)",
    key: "Unisys Limited(463)",
    value: "Unisys Limited(463)",
  },
  {
    text: "Virgin Media Limited(465)",
    key: "Virgin Media Limited(465)",
    value: "Virgin Media Limited(465)",
  },
  {
    text: "Sears Communications Ltd(467)",
    key: "Sears Communications Ltd(467)",
    value: "Sears Communications Ltd(467)",
  },
  {
    text: "Vantage Communications Ltd(468)",
    key: "Vantage Communications Ltd(468)",
    value: "Vantage Communications Ltd(468)",
  },
  {
    text: "SoldierNET Limited(469)",
    key: "SoldierNET Limited(469)",
    value: "SoldierNET Limited(469)",
  },
  {
    text: "Lansdowne Telecom Limited(470)",
    key: "Lansdowne Telecom Limited(470)",
    value: "Lansdowne Telecom Limited(470)",
  },
  {
    text: "Virgin Media Limited(471)",
    key: "Virgin Media Limited(471)",
    value: "Virgin Media Limited(471)",
  },
  {
    text: "Virgin Media Limited(472)",
    key: "Virgin Media Limited(472)",
    value: "Virgin Media Limited(472)",
  },
  {
    text: "Sark Telecom B.V.(474)",
    key: "Sark Telecom B.V.(474)",
    value: "Sark Telecom B.V.(474)",
  },
  {
    text: "i.net communications Group PLC(475)",
    key: "i.net communications Group PLC(475)",
    value: "i.net communications Group PLC(475)",
  },
  {
    text: "Maintel Voice & Data Limited(477)",
    key: "Maintel Voice & Data Limited(477)",
    value: "Maintel Voice & Data Limited(477)",
  },
  {
    text: "Greystone Telecom Limited(478)",
    key: "Greystone Telecom Limited(478)",
    value: "Greystone Telecom Limited(478)",
  },
  {
    text: "BlueBill Ltd(479)",
    key: "BlueBill Ltd(479)",
    value: "BlueBill Ltd(479)",
  },
  {
    text: "Virgin Media Limited(480)",
    key: "Virgin Media Limited(480)",
    value: "Virgin Media Limited(480)",
  },
  {
    text: "Virgin Media Limited(481)",
    key: "Virgin Media Limited(481)",
    value: "Virgin Media Limited(481)",
  },
  {
    text: "Virgin Media Limited(482)",
    key: "Virgin Media Limited(482)",
    value: "Virgin Media Limited(482)",
  },
  {
    text: "Virgin Media Limited(483)",
    key: "Virgin Media Limited(483)",
    value: "Virgin Media Limited(483)",
  },
  {
    text: "Virgin Media Limited(485)",
    key: "Virgin Media Limited(485)",
    value: "Virgin Media Limited(485)",
  },
  {
    text: "Virgin Media Limited(486)",
    key: "Virgin Media Limited(486)",
    value: "Virgin Media Limited(486)",
  },
  {
    text: "Storacall Technology Limited(487)",
    key: "Storacall Technology Limited(487)",
    value: "Storacall Technology Limited(487)",
  },
  {
    text: "TeleSurf Limited(488)",
    key: "TeleSurf Limited(488)",
    value: "TeleSurf Limited(488)",
  },
  {
    text: "Network Business Call Limited(490)",
    key: "Network Business Call Limited(490)",
    value: "Network Business Call Limited(490)",
  },
  {
    text: "Integrated Digital Services Ltd(491)",
    key: "Integrated Digital Services Ltd(491)",
    value: "Integrated Digital Services Ltd(491)",
  },
  {
    text: "Business Phones & Networks Limited(492)",
    key: "Business Phones & Networks Limited(492)",
    value: "Business Phones & Networks Limited(492)",
  },
  {
    text: "NBCN Networks Ltd(495)",
    key: "NBCN Networks Ltd(495)",
    value: "NBCN Networks Ltd(495)",
  },
  {
    text: "8x8 UK Limited(496)",
    key: "8x8 UK Limited(496)",
    value: "8x8 UK Limited(496)",
  },
  {
    text: "Simwood eSMS Limited(498)",
    key: "Simwood eSMS Limited(498)",
    value: "Simwood eSMS Limited(498)",
  },
  {
    text: "Talk Straight Ltd(499)",
    key: "Talk Straight Ltd(499)",
    value: "Talk Straight Ltd(499)",
  },
  {
    text: "IDE Group Voice Limited(500)",
    key: "IDE Group Voice Limited(500)",
    value: "IDE Group Voice Limited(500)",
  },
  {
    text: "The Word Direct Ltd.(501)",
    key: "The Word Direct Ltd.(501)",
    value: "The Word Direct Ltd.(501)",
  },
  {
    text: "Virgin Media Limited(502)",
    key: "Virgin Media Limited(502)",
    value: "Virgin Media Limited(502)",
  },
  {
    text: "Atomstream Limited(504)",
    key: "Atomstream Limited(504)",
    value: "Atomstream Limited(504)",
  },
  {
    text: "Netserve Consultants Ltd(505)",
    key: "Netserve Consultants Ltd(505)",
    value: "Netserve Consultants Ltd(505)",
  },
  {
    text: "Mintaka Limited(506)",
    key: "Mintaka Limited(506)",
    value: "Mintaka Limited(506)",
  },
  {
    text: "Logicalis UK Limited(509)",
    key: "Logicalis UK Limited(509)",
    value: "Logicalis UK Limited(509)",
  },
  {
    text: "Invosys Limited(510)",
    key: "Invosys Limited(510)",
    value: "Invosys Limited(510)",
  },
  {
    text: "Lycamobile UK Limited(511)",
    key: "Lycamobile UK Limited(511)",
    value: "Lycamobile UK Limited(511)",
  },
  {
    text: "Integrated Business Telecommunications Ltd(513)",
    key: "Integrated Business Telecommunications Ltd(513)",
    value: "Integrated Business Telecommunications Ltd(513)",
  },
  {
    text: "Digicom Telecom Ltd(514)",
    key: "Digicom Telecom Ltd(514)",
    value: "Digicom Telecom Ltd(514)",
  },
  {
    text: "Vonage Limited(516)",
    key: "Vonage Limited(516)",
    value: "Vonage Limited(516)",
  },
  {
    text: "Crown Telecom Solutions Ltd(518)",
    key: "Crown Telecom Solutions Ltd(518)",
    value: "Crown Telecom Solutions Ltd(518)",
  },
  {
    text: "Town & Country Communications LLP(519)",
    key: "Town & Country Communications LLP(519)",
    value: "Town & Country Communications LLP(519)",
  },
  { text: "Trooli Ltd(520)", key: "Trooli Ltd(520)", value: "Trooli Ltd(520)" },
  {
    text: "Ace Call Limited(521)",
    key: "Ace Call Limited(521)",
    value: "Ace Call Limited(521)",
  },
  {
    text: "The Link Stores Limited(522)",
    key: "The Link Stores Limited(522)",
    value: "The Link Stores Limited(522)",
  },
  {
    text: "CANCOM MANAGED SERVICES LTD(523)",
    key: "CANCOM MANAGED SERVICES LTD(523)",
    value: "CANCOM MANAGED SERVICES LTD(523)",
  },
  {
    text: "Cotswold Community Networks Limited(524)",
    key: "Cotswold Community Networks Limited(524)",
    value: "Cotswold Community Networks Limited(524)",
  },
  {
    text: "Uniworld Bureau Services(525)",
    key: "Uniworld Bureau Services(525)",
    value: "Uniworld Bureau Services(525)",
  },
  {
    text: "Odyssey Systems Ltd(527)",
    key: "Odyssey Systems Ltd(527)",
    value: "Odyssey Systems Ltd(527)",
  },
  { text: "Entigy Ltd(528)", key: "Entigy Ltd(528)", value: "Entigy Ltd(528)" },
  {
    text: "SCD Group Limited(529)",
    key: "SCD Group Limited(529)",
    value: "SCD Group Limited(529)",
  },
  {
    text: "Loop Scorpio Ltd(530)",
    key: "Loop Scorpio Ltd(530)",
    value: "Loop Scorpio Ltd(530)",
  },
  {
    text: "Virgin Media Limited(531)",
    key: "Virgin Media Limited(531)",
    value: "Virgin Media Limited(531)",
  },
  {
    text: "Virgin Media Limited(532)",
    key: "Virgin Media Limited(532)",
    value: "Virgin Media Limited(532)",
  },
  {
    text: "Virgin Media Limited(533)",
    key: "Virgin Media Limited(533)",
    value: "Virgin Media Limited(533)",
  },
  {
    text: "Virgin Media Limited(534)",
    key: "Virgin Media Limited(534)",
    value: "Virgin Media Limited(534)",
  },
  {
    text: "Virgin Media Limited(535)",
    key: "Virgin Media Limited(535)",
    value: "Virgin Media Limited(535)",
  },
  {
    text: "Virgin Media Limited(536)",
    key: "Virgin Media Limited(536)",
    value: "Virgin Media Limited(536)",
  },
  {
    text: "VoiceHost Limited(537)",
    key: "VoiceHost Limited(537)",
    value: "VoiceHost Limited(537)",
  },
  {
    text: "Performance Telecom Limited(539)",
    key: "Performance Telecom Limited(539)",
    value: "Performance Telecom Limited(539)",
  },
  {
    text: "Net Support UK Ltd(540)",
    key: "Net Support UK Ltd(540)",
    value: "Net Support UK Ltd(540)",
  },
  {
    text: "Virgin Media Limited(541)",
    key: "Virgin Media Limited(541)",
    value: "Virgin Media Limited(541)",
  },
  {
    text: "Virgin Media Limited(542)",
    key: "Virgin Media Limited(542)",
    value: "Virgin Media Limited(542)",
  },
  {
    text: "Virgin Media Limited(543)",
    key: "Virgin Media Limited(543)",
    value: "Virgin Media Limited(543)",
  },
  {
    text: "Virgin Media Limited(544)",
    key: "Virgin Media Limited(544)",
    value: "Virgin Media Limited(544)",
  },
  {
    text: "Hyperoptic Ltd(548)",
    key: "Hyperoptic Ltd(548)",
    value: "Hyperoptic Ltd(548)",
  },
  {
    text: "Kalnet4U Ltd(549)",
    key: "Kalnet4U Ltd(549)",
    value: "Kalnet4U Ltd(549)",
  },
  {
    text: "Virgin Media Limited(551)",
    key: "Virgin Media Limited(551)",
    value: "Virgin Media Limited(551)",
  },
  {
    text: "Virgin Media Limited(552)",
    key: "Virgin Media Limited(552)",
    value: "Virgin Media Limited(552)",
  },
  {
    text: "Virgin Media Limited(553)",
    key: "Virgin Media Limited(553)",
    value: "Virgin Media Limited(553)",
  },
  {
    text: "Virgin Media Limited(554)",
    key: "Virgin Media Limited(554)",
    value: "Virgin Media Limited(554)",
  },
  {
    text: "Virgin Media Limited(555)",
    key: "Virgin Media Limited(555)",
    value: "Virgin Media Limited(555)",
  },
  {
    text: "Magdalene Limited(559)",
    key: "Magdalene Limited(559)",
    value: "Magdalene Limited(559)",
  },
  {
    text: "UK Wholesale Direct(560)",
    key: "UK Wholesale Direct(560)",
    value: "UK Wholesale Direct(560)",
  },
  {
    text: "Glide Business Limited(562)",
    key: "Glide Business Limited(562)",
    value: "Glide Business Limited(562)",
  },
  {
    text: "A & K Communications Limited(563)",
    key: "A & K Communications Limited(563)",
    value: "A & K Communications Limited(563)",
  },
  {
    text: "Virtual1 Limited(566)",
    key: "Virtual1 Limited(566)",
    value: "Virtual1 Limited(566)",
  },
  {
    text: "Exchange Communications Ltd(567)",
    key: "Exchange Communications Ltd(567)",
    value: "Exchange Communications Ltd(567)",
  },
  {
    text: "Internet Central Limited(568)",
    key: "Internet Central Limited(568)",
    value: "Internet Central Limited(568)",
  },
  { text: "Tismi BV(569)", key: "Tismi BV(569)", value: "Tismi BV(569)" },
  {
    text: "Unite Communications Limited(570)",
    key: "Unite Communications Limited(570)",
    value: "Unite Communications Limited(570)",
  },
  {
    text: "Virgin Media Limited(571)",
    key: "Virgin Media Limited(571)",
    value: "Virgin Media Limited(571)",
  },
  {
    text: "Virgin Media Limited(572)",
    key: "Virgin Media Limited(572)",
    value: "Virgin Media Limited(572)",
  },
  {
    text: "Gzilch Limited(574)",
    key: "Gzilch Limited(574)",
    value: "Gzilch Limited(574)",
  },
  {
    text: "Innov@te Ltd(575)",
    key: "Innov@te Ltd(575)",
    value: "Innov@te Ltd(575)",
  },
  {
    text: "Matrix Platinum Limited(576)",
    key: "Matrix Platinum Limited(576)",
    value: "Matrix Platinum Limited(576)",
  },
  {
    text: "Clearstream technology Ltd(577)",
    key: "Clearstream technology Ltd(577)",
    value: "Clearstream technology Ltd(577)",
  },
  {
    text: "Wyre Communications Limited(578)",
    key: "Wyre Communications Limited(578)",
    value: "Wyre Communications Limited(578)",
  },
  {
    text: "Active Voice & Data Ltd(579)",
    key: "Active Voice & Data Ltd(579)",
    value: "Active Voice & Data Ltd(579)",
  },
  {
    text: "Telephone Box Limited(580)",
    key: "Telephone Box Limited(580)",
    value: "Telephone Box Limited(580)",
  },
  {
    text: "SPT Worldwide Ltd(581)",
    key: "SPT Worldwide Ltd(581)",
    value: "SPT Worldwide Ltd(581)",
  },
  {
    text: "Natural Enterprise Limited(583)",
    key: "Natural Enterprise Limited(583)",
    value: "Natural Enterprise Limited(583)",
  },
  {
    text: "Connaught Communication Systems Limited(584)",
    key: "Connaught Communication Systems Limited(584)",
    value: "Connaught Communication Systems Limited(584)",
  },
  {
    text: "Optimity Ltd(585)",
    key: "Optimity Ltd(585)",
    value: "Optimity Ltd(585)",
  },
  {
    text: "Andrews & Arnold Ltd(586)",
    key: "Andrews & Arnold Ltd(586)",
    value: "Andrews & Arnold Ltd(586)",
  },
  {
    text: "Orca Telecom Ltd(587)",
    key: "Orca Telecom Ltd(587)",
    value: "Orca Telecom Ltd(587)",
  },
  {
    text: "Orbtalk Limited(588)",
    key: "Orbtalk Limited(588)",
    value: "Orbtalk Limited(588)",
  },
  {
    text: "One Network Limited(589)",
    key: "One Network Limited(589)",
    value: "One Network Limited(589)",
  },
  {
    text: "Group 3 Technology Limited(591)",
    key: "Group 3 Technology Limited(591)",
    value: "Group 3 Technology Limited(591)",
  },
  {
    text: "City Numbers Ltd(592)",
    key: "City Numbers Ltd(592)",
    value: "City Numbers Ltd(592)",
  },
  { text: "In2com Ltd(593)", key: "In2com Ltd(593)", value: "In2com Ltd(593)" },
  {
    text: "NEG Technologies Limited(594)",
    key: "NEG Technologies Limited(594)",
    value: "NEG Technologies Limited(594)",
  },
  {
    text: "DuoCall Communications Ltd(595)",
    key: "DuoCall Communications Ltd(595)",
    value: "DuoCall Communications Ltd(595)",
  },
  {
    text: "IP Integration Limited(596)",
    key: "IP Integration Limited(596)",
    value: "IP Integration Limited(596)",
  },
  {
    text: "TESLA LOGIC LTD(597)",
    key: "TESLA LOGIC LTD(597)",
    value: "TESLA LOGIC LTD(597)",
  },
  {
    text: "Solutios Limited(599)",
    key: "Solutios Limited(599)",
    value: "Solutios Limited(599)",
  },
  {
    text: "Zamir Telecom Limited(600)",
    key: "Zamir Telecom Limited(600)",
    value: "Zamir Telecom Limited(600)",
  },
  {
    text: "Virgin Media Limited(601)",
    key: "Virgin Media Limited(601)",
    value: "Virgin Media Limited(601)",
  },
  {
    text: "Cloud Telecom Ltd(602)",
    key: "Cloud Telecom Ltd(602)",
    value: "Cloud Telecom Ltd(602)",
  },
  {
    text: "Virgin Media Limited(603)",
    key: "Virgin Media Limited(603)",
    value: "Virgin Media Limited(603)",
  },
  {
    text: "Turquoise Mobile Limited(604)",
    key: "Turquoise Mobile Limited(604)",
    value: "Turquoise Mobile Limited(604)",
  },
  {
    text: "Structured Communications Limited(605)",
    key: "Structured Communications Limited(605)",
    value: "Structured Communications Limited(605)",
  },
  {
    text: "Aloha Telecommunications Limited(606)",
    key: "Aloha Telecommunications Limited(606)",
    value: "Aloha Telecommunications Limited(606)",
  },
  {
    text: "Square Systems Limited(607)",
    key: "Square Systems Limited(607)",
    value: "Square Systems Limited(607)",
  },
  {
    text: "Internexus Networks Limited(608)",
    key: "Internexus Networks Limited(608)",
    value: "Internexus Networks Limited(608)",
  },
  {
    text: "Voicetec Systems Ltd(609)",
    key: "Voicetec Systems Ltd(609)",
    value: "Voicetec Systems Ltd(609)",
  },
  {
    text: "Cloudcall Limited(610)",
    key: "Cloudcall Limited(610)",
    value: "Cloudcall Limited(610)",
  },
  {
    text: "Virgin Media Limited(611)",
    key: "Virgin Media Limited(611)",
    value: "Virgin Media Limited(611)",
  },
  {
    text: "Virgin Media Limited(612)",
    key: "Virgin Media Limited(612)",
    value: "Virgin Media Limited(612)",
  },
  {
    text: "Aspire Technology Solutions Ltd(613)",
    key: "Aspire Technology Solutions Ltd(613)",
    value: "Aspire Technology Solutions Ltd(613)",
  },
  {
    text: "BT Lancashire Services Limited(614)",
    key: "BT Lancashire Services Limited(614)",
    value: "BT Lancashire Services Limited(614)",
  },
  {
    text: "Red Matter Limited(615)",
    key: "Red Matter Limited(615)",
    value: "Red Matter Limited(615)",
  },
  { text: "Noble Tel(616)", key: "Noble Tel(616)", value: "Noble Tel(616)" },
  {
    text: "Zsquare Global Solutions Ltd(617)",
    key: "Zsquare Global Solutions Ltd(617)",
    value: "Zsquare Global Solutions Ltd(617)",
  },
  {
    text: "Open Telecom Limited(618)",
    key: "Open Telecom Limited(618)",
    value: "Open Telecom Limited(618)",
  },
  {
    text: "Univoice Limited(619)",
    key: "Univoice Limited(619)",
    value: "Univoice Limited(619)",
  },
  {
    text: "Worthmanor Limted T/A Shell Wholesale(620)",
    key: "Worthmanor Limted T/A Shell Wholesale(620)",
    value: "Worthmanor Limted T/A Shell Wholesale(620)",
  },
  {
    text: "Virgin Media Limited(621)",
    key: "Virgin Media Limited(621)",
    value: "Virgin Media Limited(621)",
  },
  {
    text: "Virgin Media Limited(622)",
    key: "Virgin Media Limited(622)",
    value: "Virgin Media Limited(622)",
  },
  {
    text: "Virgin Media Limited(624)",
    key: "Virgin Media Limited(624)",
    value: "Virgin Media Limited(624)",
  },
  {
    text: "Virgin Media Limited(625)",
    key: "Virgin Media Limited(625)",
    value: "Virgin Media Limited(625)",
  },
  {
    text: "Virgin Media Limited(626)",
    key: "Virgin Media Limited(626)",
    value: "Virgin Media Limited(626)",
  },
  {
    text: "Virgin Media Limited(627)",
    key: "Virgin Media Limited(627)",
    value: "Virgin Media Limited(627)",
  },
  {
    text: "Virgin Media Limited(628)",
    key: "Virgin Media Limited(628)",
    value: "Virgin Media Limited(628)",
  },
  {
    text: "Virgin Media Limited(629)",
    key: "Virgin Media Limited(629)",
    value: "Virgin Media Limited(629)",
  },
  {
    text: "Virgin Media Limited(631)",
    key: "Virgin Media Limited(631)",
    value: "Virgin Media Limited(631)",
  },
  {
    text: "Virgin Media Limited(632)",
    key: "Virgin Media Limited(632)",
    value: "Virgin Media Limited(632)",
  },
  {
    text: "Virgin Media Limited(633)",
    key: "Virgin Media Limited(633)",
    value: "Virgin Media Limited(633)",
  },
  {
    text: "Neutrino Networks Limited(634)",
    key: "Neutrino Networks Limited(634)",
    value: "Neutrino Networks Limited(634)",
  },
  {
    text: "Connexin Limited(635)",
    key: "Connexin Limited(635)",
    value: "Connexin Limited(635)",
  },
  {
    text: "York Data Services Limited(636)",
    key: "York Data Services Limited(636)",
    value: "York Data Services Limited(636)",
  },
  {
    text: "Digital Select Limited(638)",
    key: "Digital Select Limited(638)",
    value: "Digital Select Limited(638)",
  },
  {
    text: "Comtec Enterprises Limited(639)",
    key: "Comtec Enterprises Limited(639)",
    value: "Comtec Enterprises Limited(639)",
  },
  {
    text: "Virgin Media Limited(641)",
    key: "Virgin Media Limited(641)",
    value: "Virgin Media Limited(641)",
  },
  {
    text: "Virgin Media Limited(642)",
    key: "Virgin Media Limited(642)",
    value: "Virgin Media Limited(642)",
  },
  {
    text: "Virgin Media Limited(643)",
    key: "Virgin Media Limited(643)",
    value: "Virgin Media Limited(643)",
  },
  {
    text: "Virgin Media Limited(644)",
    key: "Virgin Media Limited(644)",
    value: "Virgin Media Limited(644)",
  },
  {
    text: "TTC Communications Ltd(645)",
    key: "TTC Communications Ltd(645)",
    value: "TTC Communications Ltd(645)",
  },
  {
    text: "Qubic Group Plc(646)",
    key: "Qubic Group Plc(646)",
    value: "Qubic Group Plc(646)",
  },
  {
    text: "Numbers Telecom Limited(647)",
    key: "Numbers Telecom Limited(647)",
    value: "Numbers Telecom Limited(647)",
  },
  {
    text: "London Web Limited(648)",
    key: "London Web Limited(648)",
    value: "London Web Limited(648)",
  },
  {
    text: "Newtel Limited(649)",
    key: "Newtel Limited(649)",
    value: "Newtel Limited(649)",
  },
  {
    text: "Damovo UK Limited(650)",
    key: "Damovo UK Limited(650)",
    value: "Damovo UK Limited(650)",
  },
  {
    text: "Virgin Media Limited(651)",
    key: "Virgin Media Limited(651)",
    value: "Virgin Media Limited(651)",
  },
  {
    text: "Virgin Media Limited(652)",
    key: "Virgin Media Limited(652)",
    value: "Virgin Media Limited(652)",
  },
  {
    text: "Motion Communications T/A Catalyst AMC Ltd(653)",
    key: "Motion Communications T/A Catalyst AMC Ltd(653)",
    value: "Motion Communications T/A Catalyst AMC Ltd(653)",
  },
  {
    text: "Praten Telecom Limited(654)",
    key: "Praten Telecom Limited(654)",
    value: "Praten Telecom Limited(654)",
  },
  {
    text: "Barritec Limited(655)",
    key: "Barritec Limited(655)",
    value: "Barritec Limited(655)",
  },
  {
    text: "Business Telecom Limited(656)",
    key: "Business Telecom Limited(656)",
    value: "Business Telecom Limited(656)",
  },
  {
    text: "Lycatel Services Ltd(658)",
    key: "Lycatel Services Ltd(658)",
    value: "Lycatel Services Ltd(658)",
  },
  {
    text: "Ziron Limited(659)",
    key: "Ziron Limited(659)",
    value: "Ziron Limited(659)",
  },
  {
    text: "DMV Communications Limited(660)",
    key: "DMV Communications Limited(660)",
    value: "DMV Communications Limited(660)",
  },
  {
    text: "Virgin Media Limited(661)",
    key: "Virgin Media Limited(661)",
    value: "Virgin Media Limited(661)",
  },
  {
    text: "Virgin Media Limited(662)",
    key: "Virgin Media Limited(662)",
    value: "Virgin Media Limited(662)",
  },
  {
    text: "Pure Broadband (Infrastructure) Ltd(664)",
    key: "Pure Broadband (Infrastructure) Ltd(664)",
    value: "Pure Broadband (Infrastructure) Ltd(664)",
  },
  {
    text: "Microtalk Wholesale Limited(665)",
    key: "Microtalk Wholesale Limited(665)",
    value: "Microtalk Wholesale Limited(665)",
  },
  {
    text: "Swiftel Limited(666)",
    key: "Swiftel Limited(666)",
    value: "Swiftel Limited(666)",
  },
  {
    text: "The Networking People (NorthWest) Ltd(667)",
    key: "The Networking People (NorthWest) Ltd(667)",
    value: "The Networking People (NorthWest) Ltd(667)",
  },
  {
    text: "Chalvington Communications Ltd(668)",
    key: "Chalvington Communications Ltd(668)",
    value: "Chalvington Communications Ltd(668)",
  },
  {
    text: "Supatel Limited(669)",
    key: "Supatel Limited(669)",
    value: "Supatel Limited(669)",
  },
  {
    text: "5 Rings Telecom Limited(670)",
    key: "5 Rings Telecom Limited(670)",
    value: "5 Rings Telecom Limited(670)",
  },
  {
    text: "Virgin Media Limited(671)",
    key: "Virgin Media Limited(671)",
    value: "Virgin Media Limited(671)",
  },
  {
    text: "Virgin Media Limited(672)",
    key: "Virgin Media Limited(672)",
    value: "Virgin Media Limited(672)",
  },
  {
    text: "Virgin Media Limited(673)",
    key: "Virgin Media Limited(673)",
    value: "Virgin Media Limited(673)",
  },
  {
    text: "Virgin Media Limited(674)",
    key: "Virgin Media Limited(674)",
    value: "Virgin Media Limited(674)",
  },
  {
    text: "Virgin Media Limited(675)",
    key: "Virgin Media Limited(675)",
    value: "Virgin Media Limited(675)",
  },
  {
    text: "Virgin Media Limited(676)",
    key: "Virgin Media Limited(676)",
    value: "Virgin Media Limited(676)",
  },
  {
    text: "Virgin Media Limited(677)",
    key: "Virgin Media Limited(677)",
    value: "Virgin Media Limited(677)",
  },
  {
    text: "Essensys (UK) Ltd(678)",
    key: "Essensys (UK) Ltd(678)",
    value: "Essensys (UK) Ltd(678)",
  },
  {
    text: "Tipicall Limited(680)",
    key: "Tipicall Limited(680)",
    value: "Tipicall Limited(680)",
  },
  {
    text: "Virgin Media Limited(681)",
    key: "Virgin Media Limited(681)",
    value: "Virgin Media Limited(681)",
  },
  {
    text: "Virgin Media Limited(682)",
    key: "Virgin Media Limited(682)",
    value: "Virgin Media Limited(682)",
  },
  {
    text: "Virgin Media Limited(683)",
    key: "Virgin Media Limited(683)",
    value: "Virgin Media Limited(683)",
  },
  {
    text: "Virgin Media Limited(684)",
    key: "Virgin Media Limited(684)",
    value: "Virgin Media Limited(684)",
  },
  {
    text: "Zen Internet Limited(685)",
    key: "Zen Internet Limited(685)",
    value: "Zen Internet Limited(685)",
  },
  {
    text: "Gamma Telecom Holdings Ltd(686)",
    key: "Gamma Telecom Holdings Ltd(686)",
    value: "Gamma Telecom Holdings Ltd(686)",
  },
  {
    text: "Commsworld Limited(687)",
    key: "Commsworld Limited(687)",
    value: "Commsworld Limited(687)",
  },
  {
    text: "Zestel Limited(688)",
    key: "Zestel Limited(688)",
    value: "Zestel Limited(688)",
  },
  {
    text: "NYnet Limited(689)",
    key: "NYnet Limited(689)",
    value: "NYnet Limited(689)",
  },
  {
    text: "Metronet (UK) Limited(690)",
    key: "Metronet (UK) Limited(690)",
    value: "Metronet (UK) Limited(690)",
  },
  {
    text: "Virgin Media Limited(691)",
    key: "Virgin Media Limited(691)",
    value: "Virgin Media Limited(691)",
  },
  {
    text: "Virgin Media Limited(692)",
    key: "Virgin Media Limited(692)",
    value: "Virgin Media Limited(692)",
  },
  {
    text: "Virgin Media Limited(693)",
    key: "Virgin Media Limited(693)",
    value: "Virgin Media Limited(693)",
  },
  {
    text: "Virgin Media Limited(694)",
    key: "Virgin Media Limited(694)",
    value: "Virgin Media Limited(694)",
  },
  { text: "AVCOne Ltd(695)", key: "AVCOne Ltd(695)", value: "AVCOne Ltd(695)" },
  {
    text: "Internet Connections Limited(696)",
    key: "Internet Connections Limited(696)",
    value: "Internet Connections Limited(696)",
  },
  {
    text: "Axione UK Limited(697)",
    key: "Axione UK Limited(697)",
    value: "Axione UK Limited(697)",
  },
  {
    text: "FerengiTel Limited(698)",
    key: "FerengiTel Limited(698)",
    value: "FerengiTel Limited(698)",
  },
  {
    text: "GlemNet Ltd(699)",
    key: "GlemNet Ltd(699)",
    value: "GlemNet Ltd(699)",
  },
  { text: "XoverX Ltd(700)", key: "XoverX Ltd(700)", value: "XoverX Ltd(700)" },
  {
    text: "Cloud9 Telephony Limited(701)",
    key: "Cloud9 Telephony Limited(701)",
    value: "Cloud9 Telephony Limited(701)",
  },
  {
    text: "Easynet Global Services Limited(702)",
    key: "Easynet Global Services Limited(702)",
    value: "Easynet Global Services Limited(702)",
  },
  {
    text: "Limitless Mobile Ltd(703)",
    key: "Limitless Mobile Ltd(703)",
    value: "Limitless Mobile Ltd(703)",
  },
  {
    text: "Global Reach Networks Limited(704)",
    key: "Global Reach Networks Limited(704)",
    value: "Global Reach Networks Limited(704)",
  },
  {
    text: "Opus Telecom Ltd(705)",
    key: "Opus Telecom Ltd(705)",
    value: "Opus Telecom Ltd(705)",
  },
  {
    text: "Intrado Cloud Solutions Limited(706)",
    key: "Intrado Cloud Solutions Limited(706)",
    value: "Intrado Cloud Solutions Limited(706)",
  },
  {
    text: "TelecomIQ Limited(707)",
    key: "TelecomIQ Limited(707)",
    value: "TelecomIQ Limited(707)",
  },
  {
    text: "Exponential-e Limited(708)",
    key: "Exponential-e Limited(708)",
    value: "Exponential-e Limited(708)",
  },
  {
    text: "API Telecom Limited(709)",
    key: "API Telecom Limited(709)",
    value: "API Telecom Limited(709)",
  },
  {
    text: "The Utility Factory Limited(710)",
    key: "The Utility Factory Limited(710)",
    value: "The Utility Factory Limited(710)",
  },
  {
    text: "GCI Network Solutions Ltd(711)",
    key: "GCI Network Solutions Ltd(711)",
    value: "GCI Network Solutions Ltd(711)",
  },
  {
    text: "Origin Broadband Ltd(712)",
    key: "Origin Broadband Ltd(712)",
    value: "Origin Broadband Ltd(712)",
  },
  {
    text: "Voice Simplified Limited(713)",
    key: "Voice Simplified Limited(713)",
    value: "Voice Simplified Limited(713)",
  },
  {
    text: "Double Edge Professional Services Ltd(715)",
    key: "Double Edge Professional Services Ltd(715)",
    value: "Double Edge Professional Services Ltd(715)",
  },
  {
    text: "Ryland Communications Ltd(716)",
    key: "Ryland Communications Ltd(716)",
    value: "Ryland Communications Ltd(716)",
  },
  {
    text: "Content Guru Ltd(718)",
    key: "Content Guru Ltd(718)",
    value: "Content Guru Ltd(718)",
  },
  {
    text: "ICC Networks Ltd(719)",
    key: "ICC Networks Ltd(719)",
    value: "ICC Networks Ltd(719)",
  },
  {
    text: "DCS Voice & Vision Ltd(720)",
    key: "DCS Voice & Vision Ltd(720)",
    value: "DCS Voice & Vision Ltd(720)",
  },
  {
    text: "SCOTNET.CO.UK LTD.(721)",
    key: "SCOTNET.CO.UK LTD.(721)",
    value: "SCOTNET.CO.UK LTD.(721)",
  },
  {
    text: "Redwood Technologies Ltd(723)",
    key: "Redwood Technologies Ltd(723)",
    value: "Redwood Technologies Ltd(723)",
  },
  {
    text: "Wavetel Limited(724)",
    key: "Wavetel Limited(724)",
    value: "Wavetel Limited(724)",
  },
  {
    text: "Sentia Global(727)",
    key: "Sentia Global(727)",
    value: "Sentia Global(727)",
  },
  {
    text: "Talk.to FZC(728)",
    key: "Talk.to FZC(728)",
    value: "Talk.to FZC(728)",
  },
  {
    text: "AQL (NUMBERING) Ltd(730)",
    key: "AQL (NUMBERING) Ltd(730)",
    value: "AQL (NUMBERING) Ltd(730)",
  },
  {
    text: "Red Telecom Solutions Ltd(731)",
    key: "Red Telecom Solutions Ltd(731)",
    value: "Red Telecom Solutions Ltd(731)",
  },
  {
    text: "Entropie Ltd(732)",
    key: "Entropie Ltd(732)",
    value: "Entropie Ltd(732)",
  },
  {
    text: "UK BROADBAND LIMITED(733)",
    key: "UK BROADBAND LIMITED(733)",
    value: "UK BROADBAND LIMITED(733)",
  },
  {
    text: "Time Communication Solutions Ltd(734)",
    key: "Time Communication Solutions Ltd(734)",
    value: "Time Communication Solutions Ltd(734)",
  },
  {
    text: "Telefónica Ireland Limited(735)",
    key: "Telefónica Ireland Limited(735)",
    value: "Telefónica Ireland Limited(735)",
  },
  {
    text: "Equate Business Solutions Limited(737)",
    key: "Equate Business Solutions Limited(737)",
    value: "Equate Business Solutions Limited(737)",
  },
  {
    text: "ETS Communications Ltd(738)",
    key: "ETS Communications Ltd(738)",
    value: "ETS Communications Ltd(738)",
  },
  {
    text: "Lyca Home Limited(739)",
    key: "Lyca Home Limited(739)",
    value: "Lyca Home Limited(739)",
  },
  {
    text: "Sipcentric Ltd(740)",
    key: "Sipcentric Ltd(740)",
    value: "Sipcentric Ltd(740)",
  },
  {
    text: "Velocity1 Limited(741)",
    key: "Velocity1 Limited(741)",
    value: "Velocity1 Limited(741)",
  },
  {
    text: "Foehn Limited(742)",
    key: "Foehn Limited(742)",
    value: "Foehn Limited(742)",
  },
  {
    text: "NGN Communications Ltd(743)",
    key: "NGN Communications Ltd(743)",
    value: "NGN Communications Ltd(743)",
  },
  {
    text: "Urbancoms Ltd(744)",
    key: "Urbancoms Ltd(744)",
    value: "Urbancoms Ltd(744)",
  },
  {
    text: "Just Utilities Ltd(745)",
    key: "Just Utilities Ltd(745)",
    value: "Just Utilities Ltd(745)",
  },
  {
    text: "Online Assistance Limited(746)",
    key: "Online Assistance Limited(746)",
    value: "Online Assistance Limited(746)",
  },
  {
    text: "Firstcom Europe UK Limited(747)",
    key: "Firstcom Europe UK Limited(747)",
    value: "Firstcom Europe UK Limited(747)",
  },
  {
    text: "RRD Communications Ltd T/A ICA(748)",
    key: "RRD Communications Ltd T/A ICA(748)",
    value: "RRD Communications Ltd T/A ICA(748)",
  },
  {
    text: "Cygnet Total Communications Limited(749)",
    key: "Cygnet Total Communications Limited(749)",
    value: "Cygnet Total Communications Limited(749)",
  },
  {
    text: "Square 1 Communications Limited(750)",
    key: "Square 1 Communications Limited(750)",
    value: "Square 1 Communications Limited(750)",
  },
  {
    text: "IP Wholesale Limited(751)",
    key: "IP Wholesale Limited(751)",
    value: "IP Wholesale Limited(751)",
  },
  {
    text: "AB Internet Limited(752)",
    key: "AB Internet Limited(752)",
    value: "AB Internet Limited(752)",
  },
  {
    text: "New Star Networks Ltd(753)",
    key: "New Star Networks Ltd(753)",
    value: "New Star Networks Ltd(753)",
  },
  {
    text: "Central Technology Limited(755)",
    key: "Central Technology Limited(755)",
    value: "Central Technology Limited(755)",
  },
  {
    text: "Club Communications Ltd(756)",
    key: "Club Communications Ltd(756)",
    value: "Club Communications Ltd(756)",
  },
  {
    text: "Ogilvie Communications(757)",
    key: "Ogilvie Communications(757)",
    value: "Ogilvie Communications(757)",
  },
  {
    text: "Millgate Connect Limited(758)",
    key: "Millgate Connect Limited(758)",
    value: "Millgate Connect Limited(758)",
  },
  {
    text: "Efar Limited(759)",
    key: "Efar Limited(759)",
    value: "Efar Limited(759)",
  },
  {
    text: "Adepteo Limited(760)",
    key: "Adepteo Limited(760)",
    value: "Adepteo Limited(760)",
  },
  {
    text: "447 Services Ltd(761)",
    key: "447 Services Ltd(761)",
    value: "447 Services Ltd(761)",
  },
  {
    text: "SERVERHOUSE LIMITED(762)",
    key: "SERVERHOUSE LIMITED(762)",
    value: "SERVERHOUSE LIMITED(762)",
  },
  {
    text: "Telemix Limited(763)",
    key: "Telemix Limited(763)",
    value: "Telemix Limited(763)",
  },
  {
    text: "Venture Telecom Limited(764)",
    key: "Venture Telecom Limited(764)",
    value: "Venture Telecom Limited(764)",
  },
  {
    text: "Wanstor Ltd(766)",
    key: "Wanstor Ltd(766)",
    value: "Wanstor Ltd(766)",
  },
  {
    text: "Mason Infotech Ltd(767)",
    key: "Mason Infotech Ltd(767)",
    value: "Mason Infotech Ltd(767)",
  },
  {
    text: "Pop Telecom Ltd(768)",
    key: "Pop Telecom Ltd(768)",
    value: "Pop Telecom Ltd(768)",
  },
  {
    text: "GO4 COMMUNICATIONS LTD(769)",
    key: "GO4 COMMUNICATIONS LTD(769)",
    value: "GO4 COMMUNICATIONS LTD(769)",
  },
  {
    text: "Challenger Mobile Communications Ltd(770)",
    key: "Challenger Mobile Communications Ltd(770)",
    value: "Challenger Mobile Communications Ltd(770)",
  },
  {
    text: "iData Com Ltd(771)",
    key: "iData Com Ltd(771)",
    value: "iData Com Ltd(771)",
  },
  {
    text: "Shine Networks Limited(772)",
    key: "Shine Networks Limited(772)",
    value: "Shine Networks Limited(772)",
  },
  {
    text: "Gamma Telecom Holdings Ltd(773)",
    key: "Gamma Telecom Holdings Ltd(773)",
    value: "Gamma Telecom Holdings Ltd(773)",
  },
  {
    text: "Gamma Telecom Holdings Ltd(774)",
    key: "Gamma Telecom Holdings Ltd(774)",
    value: "Gamma Telecom Holdings Ltd(774)",
  },
  { text: "M247 Ltd(775)", key: "M247 Ltd(775)", value: "M247 Ltd(775)" },
  {
    text: "Toople.com Limited(776)",
    key: "Toople.com Limited(776)",
    value: "Toople.com Limited(776)",
  },
  {
    text: "Serious Communications Limited(777)",
    key: "Serious Communications Limited(777)",
    value: "Serious Communications Limited(777)",
  },
  {
    text: "Uni-tel Business Communications Ltd(778)",
    key: "Uni-tel Business Communications Ltd(778)",
    value: "Uni-tel Business Communications Ltd(778)",
  },
  {
    text: "Fido Telecom Limited(779)",
    key: "Fido Telecom Limited(779)",
    value: "Fido Telecom Limited(779)",
  },
  {
    text: "Fluidone Limited(780)",
    key: "Fluidone Limited(780)",
    value: "Fluidone Limited(780)",
  },
  {
    text: "I.T Communications Limited(781)",
    key: "I.T Communications Limited(781)",
    value: "I.T Communications Limited(781)",
  },
  {
    text: "uno Communications Ltd.(782)",
    key: "uno Communications Ltd.(782)",
    value: "uno Communications Ltd.(782)",
  },
  {
    text: "Orbital Net Limited(783)",
    key: "Orbital Net Limited(783)",
    value: "Orbital Net Limited(783)",
  },
  {
    text: "Telecoms Cloud Networks Limited(784)",
    key: "Telecoms Cloud Networks Limited(784)",
    value: "Telecoms Cloud Networks Limited(784)",
  },
  { text: "Swisstok(785)", key: "Swisstok(785)", value: "Swisstok(785)" },
  {
    text: "Active Business Communications Limited(786)",
    key: "Active Business Communications Limited(786)",
    value: "Active Business Communications Limited(786)",
  },
  {
    text: "Merlin Telecommunications Limited(787)",
    key: "Merlin Telecommunications Limited(787)",
    value: "Merlin Telecommunications Limited(787)",
  },
  {
    text: "Aylesbury Vale Broadband Ltd(788)",
    key: "Aylesbury Vale Broadband Ltd(788)",
    value: "Aylesbury Vale Broadband Ltd(788)",
  },
  {
    text: "Citytalk Communications Ltd(789)",
    key: "Citytalk Communications Ltd(789)",
    value: "Citytalk Communications Ltd(789)",
  },
  {
    text: "Iomart Hosting Limited(790)",
    key: "Iomart Hosting Limited(790)",
    value: "Iomart Hosting Limited(790)",
  },
  {
    text: "Logics Technologies Ltd(791)",
    key: "Logics Technologies Ltd(791)",
    value: "Logics Technologies Ltd(791)",
  },
  {
    text: "Utilities UK Ltd(792)",
    key: "Utilities UK Ltd(792)",
    value: "Utilities UK Ltd(792)",
  },
  {
    text: "UBT (EU) Ltd(793)",
    key: "UBT (EU) Ltd(793)",
    value: "UBT (EU) Ltd(793)",
  },
  {
    text: "Digiquip Group Limited(794)",
    key: "Digiquip Group Limited(794)",
    value: "Digiquip Group Limited(794)",
  },
  {
    text: "Viatel Global Services (UK) Limited(795)",
    key: "Viatel Global Services (UK) Limited(795)",
    value: "Viatel Global Services (UK) Limited(795)",
  },
  {
    text: "Stream Networks Ltd(796)",
    key: "Stream Networks Ltd(796)",
    value: "Stream Networks Ltd(796)",
  },
  {
    text: "HTL Telecom Limited(797)",
    key: "HTL Telecom Limited(797)",
    value: "HTL Telecom Limited(797)",
  },
  {
    text: "Call Plan Solutions Ltd(798)",
    key: "Call Plan Solutions Ltd(798)",
    value: "Call Plan Solutions Ltd(798)",
  },
  {
    text: "NextGenAccess Limited(799)",
    key: "NextGenAccess Limited(799)",
    value: "NextGenAccess Limited(799)",
  },
  {
    text: "IP River Ltd(800)",
    key: "IP River Ltd(800)",
    value: "IP River Ltd(800)",
  },
  {
    text: "Microtalk Europe Limited(801)",
    key: "Microtalk Europe Limited(801)",
    value: "Microtalk Europe Limited(801)",
  },
  {
    text: "Numbergroup Utilities Ltd(802)",
    key: "Numbergroup Utilities Ltd(802)",
    value: "Numbergroup Utilities Ltd(802)",
  },
  {
    text: "Lumen Technologies UK Limited(804)",
    key: "Lumen Technologies UK Limited(804)",
    value: "Lumen Technologies UK Limited(804)",
  },
  {
    text: "Lanonyx Telecom Limited(805)",
    key: "Lanonyx Telecom Limited(805)",
    value: "Lanonyx Telecom Limited(805)",
  },
  {
    text: "Nextec UK Limited(806)",
    key: "Nextec UK Limited(806)",
    value: "Nextec UK Limited(806)",
  },
  {
    text: "Virgin Media Limited(807)",
    key: "Virgin Media Limited(807)",
    value: "Virgin Media Limited(807)",
  },
  {
    text: "Limpio Office Solutions Limited(810)",
    key: "Limpio Office Solutions Limited(810)",
    value: "Limpio Office Solutions Limited(810)",
  },
  {
    text: "PTGI International Carrier Services Ltd(811)",
    key: "PTGI International Carrier Services Ltd(811)",
    value: "PTGI International Carrier Services Ltd(811)",
  },
  { text: "AMSUK LTD(813)", key: "AMSUK LTD(813)", value: "AMSUK LTD(813)" },
  {
    text: "Yorkshire Telecommunications Ltd(814)",
    key: "Yorkshire Telecommunications Ltd(814)",
    value: "Yorkshire Telecommunications Ltd(814)",
  },
  {
    text: "TalkTalk Communications Limited(815)",
    key: "TalkTalk Communications Limited(815)",
    value: "TalkTalk Communications Limited(815)",
  },
  {
    text: "Boxx Communications Ltd(816)",
    key: "Boxx Communications Ltd(816)",
    value: "Boxx Communications Ltd(816)",
  },
  {
    text: "Virgin Media Limited(818)",
    key: "Virgin Media Limited(818)",
    value: "Virgin Media Limited(818)",
  },
  {
    text: "NFON UK Ltd(819)",
    key: "NFON UK Ltd(819)",
    value: "NFON UK Ltd(819)",
  },
  {
    text: "TalkTalk Communications Limited(820)",
    key: "TalkTalk Communications Limited(820)",
    value: "TalkTalk Communications Limited(820)",
  },
  {
    text: "M 12 Solutions Limited(821)",
    key: "M 12 Solutions Limited(821)",
    value: "M 12 Solutions Limited(821)",
  },
  {
    text: "Sky UK Limited(822)",
    key: "Sky UK Limited(822)",
    value: "Sky UK Limited(822)",
  },
  {
    text: "TelcoSwitch Limited(823)",
    key: "TelcoSwitch Limited(823)",
    value: "TelcoSwitch Limited(823)",
  },
  {
    text: "NT Independent Networks Limited(824)",
    key: "NT Independent Networks Limited(824)",
    value: "NT Independent Networks Limited(824)",
  },
  {
    text: "Virgin Media Limited(825)",
    key: "Virgin Media Limited(825)",
    value: "Virgin Media Limited(825)",
  },
  {
    text: "Wildcard UK Limited(827)",
    key: "Wildcard UK Limited(827)",
    value: "Wildcard UK Limited(827)",
  },
  {
    text: "Tango Networks UK Ltd(828)",
    key: "Tango Networks UK Ltd(828)",
    value: "Tango Networks UK Ltd(828)",
  },
  {
    text: "Gencom Technologies Ltd(831)",
    key: "Gencom Technologies Ltd(831)",
    value: "Gencom Technologies Ltd(831)",
  },
  {
    text: "4Net Technologies Limited(833)",
    key: "4Net Technologies Limited(833)",
    value: "4Net Technologies Limited(833)",
  },
  {
    text: "Idt Global Ltd(834)",
    key: "Idt Global Ltd(834)",
    value: "Idt Global Ltd(834)",
  },
  {
    text: "IOVOX Limited(836)",
    key: "IOVOX Limited(836)",
    value: "IOVOX Limited(836)",
  },
  {
    text: "NewVoiceMedia Limited(837)",
    key: "NewVoiceMedia Limited(837)",
    value: "NewVoiceMedia Limited(837)",
  },
  {
    text: "Marathon Telecom Limited(838)",
    key: "Marathon Telecom Limited(838)",
    value: "Marathon Telecom Limited(838)",
  },
  {
    text: "Core Communication Services Ltd(839)",
    key: "Core Communication Services Ltd(839)",
    value: "Core Communication Services Ltd(839)",
  },
  {
    text: "Inclarity Communications Limited(840)",
    key: "Inclarity Communications Limited(840)",
    value: "Inclarity Communications Limited(840)",
  },
  {
    text: "Bellingham Telecommunications Limited(841)",
    key: "Bellingham Telecommunications Limited(841)",
    value: "Bellingham Telecommunications Limited(841)",
  },
  {
    text: "Dial 9 Communications Limited(842)",
    key: "Dial 9 Communications Limited(842)",
    value: "Dial 9 Communications Limited(842)",
  },
  {
    text: "Supported Business Limited(843)",
    key: "Supported Business Limited(843)",
    value: "Supported Business Limited(843)",
  },
  {
    text: "Planet Numbers Ltd(844)",
    key: "Planet Numbers Ltd(844)",
    value: "Planet Numbers Ltd(844)",
  },
  {
    text: "LANtec Services Ltd(845)",
    key: "LANtec Services Ltd(845)",
    value: "LANtec Services Ltd(845)",
  },
  {
    text: "Belgacom International Carrier Services SA(846)",
    key: "Belgacom International Carrier Services SA(846)",
    value: "Belgacom International Carrier Services SA(846)",
  },
  {
    text: "ShoreTel UK Limited(847)",
    key: "ShoreTel UK Limited(847)",
    value: "ShoreTel UK Limited(847)",
  },
  {
    text: "Network Rail Infrastructure Limited(848)",
    key: "Network Rail Infrastructure Limited(848)",
    value: "Network Rail Infrastructure Limited(848)",
  },
  {
    text: "Cirrus Response Limited(849)",
    key: "Cirrus Response Limited(849)",
    value: "Cirrus Response Limited(849)",
  },
  {
    text: "Singtel Europe Ltd(850)",
    key: "Singtel Europe Ltd(850)",
    value: "Singtel Europe Ltd(850)",
  },
  {
    text: "TalkTalk Communications Limited(851)",
    key: "TalkTalk Communications Limited(851)",
    value: "TalkTalk Communications Limited(851)",
  },
  {
    text: "4D INTERACTIVE LTD(852)",
    key: "4D INTERACTIVE LTD(852)",
    value: "4D INTERACTIVE LTD(852)",
  },
  {
    text: "Telecoms Cloud Networks Limited(853)",
    key: "Telecoms Cloud Networks Limited(853)",
    value: "Telecoms Cloud Networks Limited(853)",
  },
  {
    text: "Collabortive Portfolio LTD(854)",
    key: "Collabortive Portfolio LTD(854)",
    value: "Collabortive Portfolio LTD(854)",
  },
  {
    text: "PORT 5060 LTD(855)",
    key: "PORT 5060 LTD(855)",
    value: "PORT 5060 LTD(855)",
  },
  {
    text: "QUICKLINE COMMUNICATIONS LIMITED(856)",
    key: "QUICKLINE COMMUNICATIONS LIMITED(856)",
    value: "QUICKLINE COMMUNICATIONS LIMITED(856)",
  },
  {
    text: "Wavenet UK Ltd(857)",
    key: "Wavenet UK Ltd(857)",
    value: "Wavenet UK Ltd(857)",
  },
  {
    text: "Stour Marine Limited(859)",
    key: "Stour Marine Limited(859)",
    value: "Stour Marine Limited(859)",
  },
  {
    text: "WAVECREST NETWORKS LIMITED(860)",
    key: "WAVECREST NETWORKS LIMITED(860)",
    value: "WAVECREST NETWORKS LIMITED(860)",
  },
  {
    text: "Interoute Communications Ltd(862)",
    key: "Interoute Communications Ltd(862)",
    value: "Interoute Communications Ltd(862)",
  },
  {
    text: "Hanhaa Limited(864)",
    key: "Hanhaa Limited(864)",
    value: "Hanhaa Limited(864)",
  },
  {
    text: "Syscomm Limited(865)",
    key: "Syscomm Limited(865)",
    value: "Syscomm Limited(865)",
  },
  {
    text: "Sound Advertising Ltd(867)",
    key: "Sound Advertising Ltd(867)",
    value: "Sound Advertising Ltd(867)",
  },
  {
    text: "YayYay Limited(868)",
    key: "YayYay Limited(868)",
    value: "YayYay Limited(868)",
  },
  {
    text: "Anywhere Sim Limited(869)",
    key: "Anywhere Sim Limited(869)",
    value: "Anywhere Sim Limited(869)",
  },
  {
    text: "Zapappi Ltd(871)",
    key: "Zapappi Ltd(871)",
    value: "Zapappi Ltd(871)",
  },
  {
    text: "Fuse 2 Communications Ltd(872)",
    key: "Fuse 2 Communications Ltd(872)",
    value: "Fuse 2 Communications Ltd(872)",
  },
  {
    text: "Eircom (UK) Limited(873)",
    key: "Eircom (UK) Limited(873)",
    value: "Eircom (UK) Limited(873)",
  },
  {
    text: "Eircom NI Ltd(874)",
    key: "Eircom NI Ltd(874)",
    value: "Eircom NI Ltd(874)",
  },
  {
    text: "Carters Communication Limited(875)",
    key: "Carters Communication Limited(875)",
    value: "Carters Communication Limited(875)",
  },
  { text: "VTSL Ltd(876)", key: "VTSL Ltd(876)", value: "VTSL Ltd(876)" },
  {
    text: "Antheus Telecom Limited(877)",
    key: "Antheus Telecom Limited(877)",
    value: "Antheus Telecom Limited(877)",
  },
  {
    text: "Infinity Tracking Ltd(879)",
    key: "Infinity Tracking Ltd(879)",
    value: "Infinity Tracking Ltd(879)",
  },
  {
    text: "Axe Telecom Limited(880)",
    key: "Axe Telecom Limited(880)",
    value: "Axe Telecom Limited(880)",
  },
  {
    text: "Converged Communication Solutions Ltd(881)",
    key: "Converged Communication Solutions Ltd(881)",
    value: "Converged Communication Solutions Ltd(881)",
  },
  {
    text: "Portal Voice & Data Ltd(882)",
    key: "Portal Voice & Data Ltd(882)",
    value: "Portal Voice & Data Ltd(882)",
  },
  {
    text: "Liquid 11 Limited(883)",
    key: "Liquid 11 Limited(883)",
    value: "Liquid 11 Limited(883)",
  },
  {
    text: "Pareteum Europe B.V.(885)",
    key: "Pareteum Europe B.V.(885)",
    value: "Pareteum Europe B.V.(885)",
  },
  {
    text: "Localphone Limited(886)",
    key: "Localphone Limited(886)",
    value: "Localphone Limited(886)",
  },
  {
    text: "UK BANDWIDTH LIMITED(887)",
    key: "UK BANDWIDTH LIMITED(887)",
    value: "UK BANDWIDTH LIMITED(887)",
  },
  {
    text: "Epsilon Telecommunications Ltd(888)",
    key: "Epsilon Telecommunications Ltd(888)",
    value: "Epsilon Telecommunications Ltd(888)",
  },
  {
    text: "IP Voice Networks Ltd(889)",
    key: "IP Voice Networks Ltd(889)",
    value: "IP Voice Networks Ltd(889)",
  },
  {
    text: "VOXYONDER NETWORK SERVICES UK LTD(890)",
    key: "VOXYONDER NETWORK SERVICES UK LTD(890)",
    value: "VOXYONDER NETWORK SERVICES UK LTD(890)",
  },
  {
    text: "Linear Telecoms Limited(891)",
    key: "Linear Telecoms Limited(891)",
    value: "Linear Telecoms Limited(891)",
  },
  {
    text: "EG TECHNOLOGIES LIMITED(892)",
    key: "EG TECHNOLOGIES LIMITED(892)",
    value: "EG TECHNOLOGIES LIMITED(892)",
  },
  {
    text: "BORDERLINK BROADBAND LIMITED(893)",
    key: "BORDERLINK BROADBAND LIMITED(893)",
    value: "BORDERLINK BROADBAND LIMITED(893)",
  },
  { text: "Odigo(894)", key: "Odigo(894)", value: "Odigo(894)" },
  {
    text: "TELNYX UK LIMITED(895)",
    key: "TELNYX UK LIMITED(895)",
    value: "TELNYX UK LIMITED(895)",
  },
  {
    text: "Fram Broadband Ltd(896)",
    key: "Fram Broadband Ltd(896)",
    value: "Fram Broadband Ltd(896)",
  },
  {
    text: "COMMUNITY FIBRE LIMITED(897)",
    key: "COMMUNITY FIBRE LIMITED(897)",
    value: "COMMUNITY FIBRE LIMITED(897)",
  },
  {
    text: "SiPalto Ltd(898)",
    key: "SiPalto Ltd(898)",
    value: "SiPalto Ltd(898)",
  },
  { text: "Xoom Ltd(899)", key: "Xoom Ltd(899)", value: "Xoom Ltd(899)" },
  {
    text: "VarTec Telecom (UK) Ltd(900)",
    key: "VarTec Telecom (UK) Ltd(900)",
    value: "VarTec Telecom (UK) Ltd(900)",
  },
  {
    text: "Dyfed IT Solutions Ltd(921)",
    key: "Dyfed IT Solutions Ltd(921)",
    value: "Dyfed IT Solutions Ltd(921)",
  },
  {
    text: "Twilio Ireland Limited(922)",
    key: "Twilio Ireland Limited(922)",
    value: "Twilio Ireland Limited(922)",
  },
  {
    text: "Minotaur Telecom Limited(923)",
    key: "Minotaur Telecom Limited(923)",
    value: "Minotaur Telecom Limited(923)",
  },
  {
    text: "9EONS LIMITED(924)",
    key: "9EONS LIMITED(924)",
    value: "9EONS LIMITED(924)",
  },
  {
    text: "GTT - EMEA LTD.(925)",
    key: "GTT - EMEA LTD.(925)",
    value: "GTT - EMEA LTD.(925)",
  },
  {
    text: "TRUESPEED COMMUNICATIONS LTD(926)",
    key: "TRUESPEED COMMUNICATIONS LTD(926)",
    value: "TRUESPEED COMMUNICATIONS LTD(926)",
  },
  {
    text: "ICUK Computing Services Limited(927)",
    key: "ICUK Computing Services Limited(927)",
    value: "ICUK Computing Services Limited(927)",
  },
  {
    text: "Lancashire County Council(928)",
    key: "Lancashire County Council(928)",
    value: "Lancashire County Council(928)",
  },
  {
    text: "PEERLESS NETWORK UK LIMITED(929)",
    key: "PEERLESS NETWORK UK LIMITED(929)",
    value: "PEERLESS NETWORK UK LIMITED(929)",
  },
  {
    text: "Persimmon Homes Limited(930)",
    key: "Persimmon Homes Limited(930)",
    value: "Persimmon Homes Limited(930)",
  },
  {
    text: "CINOS LIMITED(931)",
    key: "CINOS LIMITED(931)",
    value: "CINOS LIMITED(931)",
  },
  {
    text: "24 SEVEN CLOUD COMMUNICATIONS LTD(947)",
    key: "24 SEVEN CLOUD COMMUNICATIONS LTD(947)",
    value: "24 SEVEN CLOUD COMMUNICATIONS LTD(947)",
  },
  {
    text: "Number Services Ltd.(950)",
    key: "Number Services Ltd.(950)",
    value: "Number Services Ltd.(950)",
  },
  {
    text: "Jurassic Fibre Limited(966)",
    key: "Jurassic Fibre Limited(966)",
    value: "Jurassic Fibre Limited(966)",
  },
  {
    text: "Media Hawk Ltd(989)",
    key: "Media Hawk Ltd(989)",
    value: "Media Hawk Ltd(989)",
  },
  {
    text: "Internetty Ltd(994)",
    key: "Internetty Ltd(994)",
    value: "Internetty Ltd(994)",
  },
  {
    text: "Redcentric Solutions Limited(996)",
    key: "Redcentric Solutions Limited(996)",
    value: "Redcentric Solutions Limited(996)",
  },
  {
    text: "WIGHTFIBRE LIMITED(997)",
    key: "WIGHTFIBRE LIMITED(997)",
    value: "WIGHTFIBRE LIMITED(997)",
  },
];

const CNOSelect = ({ label, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        name={field.name}
        defaultValue={field.value}
        fluid
        search
        selection
        options={cnos}
        placeholder='Select CNO'
        onChange={(event, { value }) => {
          helpers.setValue(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default CNOSelect;
